export const jobs = {
  // The job page, top down (tracker sj-30).
  page: {
    state: {
      done: "تم",
      current: "أنت هنا",
      upcoming: "لاحقًا",
    },
    youAreHere: "أنت هنا",
    nextStep: {
      title: "الخطوة التالية",
      needsYou: "بانتظارك",
      changeStatusA11y: "الحالة: {{status}}. تغيير الحالة",
      giveToSomeoneElse: "إسنادها إلى شخص آخر",
      nothingLeft: "لم يتبقَّ شيء",
    },
    section: {
      what: "ما المطلوب",
      where: "أين",
      who: "من ومتى",
      before: "قبل أن تبدأ",
      beforeAny: "قبل بدء أي مهمة فرعية",
      work: "العمل",
      subJobs: "المهام الفرعية",
      costs: "التكاليف",
      finish: "عند الانتهاء",
      atTheEnd: "في النهاية",
      signOff: "الاعتماد",
      report: "التقرير",
      activity: "النشاط",
    },
    change: "تغيير",
    openReport: "فتح التقرير",
    meta: {
      doneOf: "{{done}} من {{total}}",
      updates_zero: "لا تحديثات",
      updates_one: "تحديث واحد",
      updates_two: "تحديثان",
      updates_few: "{{count}} تحديثات",
      updates_many: "{{count}} تحديثًا",
      updates_other: "{{count}} تحديث",
      estimate: "تقديريًا {{amount}}",
    },
    summary: {
      nobodyYet: "لا أحد بعد",
      workDone: "تم العمل",
      signedOff: "تم الاعتماد",
      waitingSignOff: "بانتظار الاعتماد",
      reportLater: "جاهز بعد إنجاز العمل",
      costsLater: "تُضاف عند بدء العمل",
      noCosts: "لم تُسجَّل أي تكاليف",
      signOffLater: "بعد إنجاز العمل",
    },
  },
  visits: {
    showMe: "أرني",
    title: "الزيارات",
    empty: "زيارة واحدة حتى الآن. خطّط لزيارة أخرى إذا احتاج العمل أكثر من يوم.",
    visitNo: "الزيارة {{no}}",
    arrive: "وصلت",
    arrived: "تم تسجيل الوصول",
    move: "نقل الزيارة",
    moveTitle: "نقل الزيارة {{no}}",
    moved: "تم نقل الزيارة",
    notes: "ملاحظات اليوم",
    notesTitle: "ملاحظات الزيارة {{no}}",
    notesMessage: "ما الذي أُنجز في هذه الزيارة؟",
    notesSaved: "تم حفظ الملاحظات",
    cancel: "إلغاء الزيارة",
    cancelled: "تم إلغاء الزيارة",
    add: "تخطيط زيارة",
    addAnother: "تخطيط زيارة أخرى",
    addTitle: "تخطيط زيارة",
    addHint: "يعود الشخص نفسه في يوم آخر. يُكمل العمل مرة واحدة في النهاية.",
    added: "تم تخطيط الزيارة",
    comeBack: "أحتاج إلى العودة",
    comeBackTitle: "أحتاج إلى العودة",
    comeBackHint: "تنتهي زيارة اليوم هنا ويُخطط للزيارة التالية. يبقى العمل مفتوحًا.",
    comeBackReason: "لماذا تحتاج إلى العودة؟",
    todayNotes: "ما أُنجز اليوم (اختياري)",
    nextDay: "الزيارة التالية",
    comeBackConfirm: "تخطيط الزيارة التالية",
    comeBackSaved: "تم تخطيط الزيارة التالية",
    comeBackBecause: "سيعود: {{reason}}",
    day: "اليوم",
    time: "الوقت",
    save: "حفظ",
    cancelSheet: "إلغاء",
    photosHint: "أضف صور الزيارة إلى نشاط العمل في اليوم نفسه.",
    failedTitle: "تعذّر تحديث الزيارات",
    failedBody: "يُرجى المحاولة مرة أخرى.",
    count_zero: "لا زيارات",
    count_one: "زيارة واحدة",
    count_two: "زيارتان",
    count_few: "{{count}} زيارات",
    count_many: "{{count}} زيارة",
    count_other: "{{count}} زيارة",
    status: {
      planned: "مخططة",
      arrived: "في الموقع منذ {{time}}",
      done: "تمت",
      cancelled: "ملغاة",
    },
  },
  subJobs: {
    title: "مهام فرعية",
    progress: "تم {{done}} من {{total}}",
    toCheck: "{{n}} بانتظار التحقق",
    empty: "قسّم هذه المهمة إلى أعمال أصغر، لكل منها شخص وتاريخ. تنتظر هذه المهمة حتى تكتمل جميعها.",
    add: "إضافة مهمة فرعية",
    inOrder: "تنفيذها بالترتيب",
    partOf: "جزء من {{title}}",
    partOfUnknown: "جزء من مهمة أكبر",
    unassigned: "لم تُسند بعد",
    waiting: "بانتظار السابقة",
    waitsFor: "تنتظر انتهاء \"{{title}}\" أولاً.",
    cost: "تكلفة المهام الفرعية حتى الآن: {{amount}}",
    created: "تمت إضافة المهمة الفرعية",
    sheetTitle: "إضافة مهمة فرعية",
    orderFailedTitle: "تعذّر تغيير الترتيب",
    orderFailedBody: "تحقق من الاتصال وحاول مرة أخرى.",
    asOneJob: "اجعلها مهمة واحدة بمهام فرعية",
    asOneJobHint: "مهمة واحدة تضم الـ {{n}}، لكل منها شخص وتاريخ. تُغلق عند اكتمالها جميعاً.",
    parentTitle: "إصلاح الملاحظات على {{asset}}",
    parentTitleNoAsset: "إصلاح ملاحظات الفحص",
    parentBrief: "تضم {{n}} مهام فرعية، واحدة لكل ملاحظة. تنتظر حتى تكتمل جميعها.",
    openBlocksComplete_zero: "لا توجد مهام فرعية مفتوحة.",
    openBlocksComplete_one: "لا تزال مهمة فرعية واحدة مفتوحة. أنهِها أو ألغِها قبل إكمال هذه المهمة.",
    openBlocksComplete_two: "لا تزال مهمتان فرعيتان مفتوحتين. أنهِهما أو ألغِهما قبل إكمال هذه المهمة.",
    openBlocksComplete_few: "لا تزال {{count}} مهام فرعية مفتوحة. أنهِها أو ألغِها قبل إكمال هذه المهمة.",
    openBlocksComplete_many: "لا تزال {{count}} مهمة فرعية مفتوحة. أنهِها أو ألغِها قبل إكمال هذه المهمة.",
    openBlocksComplete_other: "لا تزال {{count}} مهمة فرعية مفتوحة. أنهِها أو ألغِها قبل إكمال هذه المهمة.",
    family: {
      status: {
        cancelled: "ملغاة",
        signed_off: "معتمدة",
        needs_you: "تحتاجك",
        ready_to_sign_off: "جاهزة للاعتماد",
        in_progress: "قيد التنفيذ",
        scheduled: "مجدولة",
        waiting: "بانتظار",
      },
      needs: {
        over_budget: "تجاوزت تكاليف المهام الفرعية ميزانية المهمة.",
        declined: "رُفضت مهمة فرعية. أسندها إلى شخص آخر ليستمر العمل.",
        cant_complete: "لا يستطيع أحدهم إنجاز مهمته الفرعية في موعدها. قرّر ذلك من المهمة الفرعية.",
        sent_back: "أُعيدت مهمة فرعية ويُعاد تنفيذها.",
        late: "مهمة فرعية متأخرة. ذكّر بها أو أعد إسنادها أو انقلها.",
      },
      runBy: "يديرها {{name}}",
      runByNobody: "لا أحد يدير هذه المهمة بعد",
      changeOwner: "تغيير من يديرها",
      budget: "الميزانية {{budget}} · حتى الآن {{spent}}",
      overBudget: "تجاوزت الميزانية بمقدار {{amount}}",
      forecast: "الانتهاء المتوقع {{date}}",
      due: "الاستحقاق {{date}}",
      checked: "تم الفحص",
      needsCheck: "منجزة: افحصها",
      waitsForList: "تنتظر {{titles}}",
      late: "متأخرة",
      showAll: "عرض الكل ({{total}})",
      showFewer: "عرض أقل",
      check: "فحص العمل",
      checkedToast: "تم فحص العمل",
      youAreHere: "أنت هنا",
      stepOf: "المهمة الفرعية {{n}} من {{total}}",
      previous: "السابقة",
      next: "التالية",
      menu: {
        title: "{{title}}",
        open: "فتح",
        start: "بدء",
        schedule: "جدولة",
        reassign: "إعادة إسناد",
        remind: "تذكير",
        pause: "إيقاف مؤقت",
        skip: "تخطٍّ مع ذكر السبب",
        check: "فحص العمل",
        sendBack: "إعادة",
        askPhotos: "طلب صور",
        waitsFor: "ما الذي تنتظره",
        separate: "جعلها مهمة مستقلة",
        moveTo: "نقلها إلى مهمة أخرى",
        run: "إدارة",
        review: "مراجعة",
        family: "المهمة",
      },
      reminded: "تم إرسال التذكير",
      remindedAlready: "لا شيء للتذكير به: إنها منجزة أو غير مسندة لأحد.",
      skipTitle: "تخطي هذه المهمة الفرعية؟",
      skipMessage: "تُحتسب منجزة للمهمة ولا تظهر أبدًا كعمل مُنفَّذ.",
      skipPlaceholder: "لماذا لا حاجة إليها؟",
      skipConfirm: "تخطَّها",
      skipped: "تم تخطي المهمة الفرعية",
      sendBackTitle: "إعادتها",
      sendBackMessage: "اذكر ما يجب إعادة تنفيذه. سيُبلَّغ {{name}}، ويُفحص العمل مجددًا عند إنجازه.",
      sendBackPlaceholder: "ما الذي يجب إعادته؟",
      sendBackConfirm: "إعادة",
      sentBack: "أُعيدت",
      askPhotosTitle: "طلب صور",
      askPhotosMessage: "اذكر ما تحتاج إلى رؤيته. تبقى منجزة بينما يضيفها {{name}}.",
      askPhotosPlaceholder: "ما الذي تحتاج إلى رؤيته؟",
      askPhotosConfirm: "اطلب",
      asked: "تم طلب الصور",
      pausePlaceholder: "لماذا أُوقفت؟",
      pauseTitle: "إيقاف هذه المهمة الفرعية مؤقتًا؟",
      pauseConfirm: "إيقاف مؤقت",
      paused: "متوقفة مؤقتًا",
      separateTitle: "جعلها مهمة مستقلة؟",
      separateMessage: "تخرج من هذه المهمة وتحتفظ بشخصها ومواعيدها وسجلها. لن تنتظرها هذه المهمة بعد الآن.",
      separateConfirm: "افصلها",
      separated: "أصبحت مهمة مستقلة",
      signOff: "اعتماد المهمة كاملة",
      signOffHint_zero: "يعتمد هذه المهمة.",
      signOffHint_one: "يعتمد هذه المهمة ومهمتها الفرعية المنجزة معًا.",
      signOffHint_two: "يعتمد هذه المهمة ومهمتيها الفرعيتين المنجزتين معًا.",
      signOffHint_few: "يعتمد هذه المهمة و{{count}} مهام فرعية منجزة معًا.",
      signOffHint_many: "يعتمد هذه المهمة و{{count}} مهمة فرعية منجزة معًا.",
      signOffHint_other: "يعتمد هذه المهمة و{{count}} مهمة فرعية منجزة معًا.",
      signOffFor: "جاهزة ليعتمدها {{name}}.",
      signedOff: "تم اعتماد المهمة",
      approvalEach: "أفحص كل مهمة فرعية عند إنجازها",
      approvalEachHint: "لا تبدأ التالية إلا بعد فحصك. عند الإيقاف: يفحص المعتمِد كل شيء مرة واحدة عند الاعتماد.",
      moveAll: "نقل كل المواعيد",
      moveAllTitle: "نقل المهام الفرعية المفتوحة",
      moveAllMessage: "بكم يومًا؟ ضع علامة الطرح لتقديمها.",
      moveAllConfirm: "نقل",
      movedDates_zero: "لم تُنقل أي مهمة فرعية",
      movedDates_one: "نُقلت مهمة فرعية واحدة",
      movedDates_two: "نُقلت مهمتان فرعيتان",
      movedDates_few: "نُقلت {{count}} مهام فرعية",
      movedDates_many: "نُقلت {{count}} مهمة فرعية",
      movedDates_other: "نُقلت {{count}} مهمة فرعية",
      moveDaysInvalid: "أدخل عددًا صحيحًا من الأيام، مثل 2 أو ‎-1.",
      cancelAll: "إلغاء المهمة كاملة",
      cancelAllTitle: "إلغاء المهمة كاملة؟",
      cancelAllMessage: "تُلغى المهمة وكل المهام الفرعية غير المنجزة، ويُبلَّغ أصحابها. يحتفظ العمل المنجز بسجله.",
      cancelAllPlaceholder: "لماذا؟ (اختياري)",
      cancelAllConfirm: "إلغاء المهمة",
      cancelledAll_zero: "أُلغيت المهمة دون مهام فرعية مفتوحة",
      cancelledAll_one: "أُلغيت المهمة مع مهمة فرعية مفتوحة واحدة",
      cancelledAll_two: "أُلغيت المهمة مع مهمتين فرعيتين مفتوحتين",
      cancelledAll_few: "أُلغيت المهمة مع {{count}} مهام فرعية مفتوحة",
      cancelledAll_many: "أُلغيت المهمة مع {{count}} مهمة فرعية مفتوحة",
      cancelledAll_other: "أُلغيت المهمة مع {{count}} مهمة فرعية مفتوحة",
      more: "المزيد لهذه المهمة",
      failedTitle: "تعذّر ذلك",
      failedBody: "تحقق من الاتصال وحاول مرة أخرى.",
      waitsForTitle: "ماذا تنتظر «{{title}}»؟",
      waitsForNone: "لا شيء: يمكن أن تبدأ في أي وقت",
      waitsForSaved: "تم الحفظ",
      addExisting: "إضافة مهمة موجودة",
      addExistingTitle: "إضافة مهمة موجودة",
      addExistingEmpty: "لا توجد مهمة مفتوحة في هذا الموقع يمكن إضافتها.",
      added: "أُضيفت إلى هذه المهمة",
      moveToTitle: "نقلها إلى أي مهمة؟",
      moveToEmpty: "لا توجد مهمة مفتوحة أخرى في هذا الموقع.",
      movedTo: "تم النقل",
      planTitle: "تخطيط المهام الفرعية",
      planHint: "يُنجز العمل نفسه في المهام الفرعية. تُغلق هذه المهمة عند إنجازها كلها{{checked}}.",
      planHintChecked: " وفحصها",
      slipTitle_zero: "نقل المهام الفرعية التي تنتظر هذه؟",
      slipTitle_one: "نقل المهمة الفرعية التي تنتظر هذه؟",
      slipTitle_two: "نقل المهمتين الفرعيتين اللتين تنتظران هذه؟",
      slipTitle_few: "نقل {{count}} مهام فرعية تنتظر هذه؟",
      slipTitle_many: "نقل {{count}} مهمة فرعية تنتظر هذه؟",
      slipTitle_other: "نقل {{count}} مهمة فرعية تنتظر هذه؟",
      slipMessage_zero: "تحركت هذه {{count}} يوم {{direction}}.",
      slipMessage_one: "تحركت هذه يومًا واحدًا {{direction}}. انقلها بالقدر نفسه ليبقى الترتيب.",
      slipMessage_two: "تحركت هذه يومين {{direction}}. انقلها بالقدر نفسه ليبقى الترتيب.",
      slipMessage_few: "تحركت هذه {{count}} أيام {{direction}}. انقلها بالقدر نفسه ليبقى الترتيب.",
      slipMessage_many: "تحركت هذه {{count}} يومًا {{direction}}. انقلها بالقدر نفسه ليبقى الترتيب.",
      slipMessage_other: "تحركت هذه {{count}} يوم {{direction}}. انقلها بالقدر نفسه ليبقى الترتيب.",
      later: "إلى الأمام",
      earlier: "إلى الخلف",
      budgetSet: "تحديد ميزانية",
      budgetMessage: "تُحتسب تكاليف المهام الفرعية منها، وتُبلَّغ عند تجاوزها. أدخل 0 لإزالتها.",
      budgetConfirm: "حفظ",
      budgetInvalid: "أدخل مبلغًا، مثل 2500.",
      budgetSaved: "تم حفظ الميزانية",
      timeline: {
        today: "اليوم",
        forecast: "الانتهاء المتوقع",
        undated_zero: "لا توجد مهام فرعية بلا تاريخ",
        undated_one: "مهمة فرعية واحدة بلا تاريخ بعد",
        undated_two: "مهمتان فرعيتان بلا تاريخ بعد",
        undated_few: "{{count}} مهام فرعية بلا تاريخ بعد",
        undated_many: "{{count}} مهمة فرعية بلا تاريخ بعد",
        undated_other: "{{count}} مهمة فرعية بلا تاريخ بعد",
      },
      activityFromSubJobs: "من المهام الفرعية",
      activityLabel: "المهمة الفرعية {{n}}: {{title}}",
      addToThisJob: "أضف إلى هذه المهمة",
      separateJob: "مهمة منفصلة",
      addedToThisJob: "أضيفت كمهمة فرعية تالية",
      extraWaiting: "عمل إضافي ينتظر قرارك: {{title}}",
      sentToRequester: "أُرسلت إلى مقدّم الطلب للتأكيد. اعتمدها بعد موافقته.",
      waitsForRequester: "يؤكد مقدّم الطلب المهمة كلها أولاً، ثم تعتمدها أنت.",
      template: {
        use: "أضف مهامًا فرعية من قالب",
        save: "احفظ كقالب",
        saveMessage: "يحفظ هذه المهام الفرعية وترتيبها وما ينتظر ماذا. لا تُحفظ الأشخاص أو التواريخ أو التكاليف.",
        saveConfirm: "احفظ القالب",
        saved: "حُفظ باسم \"{{name}}\"",
        pickTitle: "القوالب",
        manage: "إدارة",
        delete: "احذف \"{{name}}\"",
        deleted: "حُذف القالب",
        empty: "لا توجد قوالب بعد. احفظ أولاً مهمة لها مهام فرعية كقالب.",
        row_zero: "{{name}} · بلا خطوات",
        row_one: "{{name}} · خطوة واحدة",
        row_two: "{{name}} · خطوتان",
        row_few: "{{name}} · {{count}} خطوات",
        row_many: "{{name}} · {{count}} خطوة",
        row_other: "{{name}} · {{count}} خطوة",
        applied_zero: "لم تُضف مهام فرعية",
        applied_one: "أضيفت مهمة فرعية واحدة",
        applied_two: "أضيفت مهمتان فرعيتان",
        applied_few: "أضيفت {{count}} مهام فرعية",
        applied_many: "أضيفت {{count}} مهمة فرعية",
        applied_other: "أضيفت {{count}} مهمة فرعية",
      },
      showMe: "أرني",
      mainContractor: {
        handOver: "تسليم العمل لمقاول رئيسي لإدارته",
        takeBack: "استعادة العمل",
        takeBackTitle: "استعادة العمل؟",
        takeBackMessage: "يتوقف {{name}} عن إدارة هذا العمل وتعود أنت لإدارته. تبقى الأعمال الفرعية المسلّمة مع من استلمها.",
        takenBack: "أنت تدير هذا العمل مجددًا",
        pickTitle: "أي مقاول يدير هذا العمل؟",
        allowTitle: "هل يمكن لـ {{name}} الاستعانة بمقاوليك أيضًا؟",
        allowYes: "نعم، يمكنه إسناد أعمال فرعية لمقاولينا",
        allowNo: "لا، فريقه فقط",
        handedOver: "{{name}} يدير هذا العمل الآن",
        youRunIt: "أنت تدير هذا العمل للعميل. أضف أعمالًا فرعية لفريقك؛ ويعتمد العميل العمل في النهاية.",
        runsIt: "مقاول رئيسي يدير هذا العمل. أنت تعتمده في النهاية.",
        nameCrew: "تسمية الفريق",
        nameCrewMessage: "من في فريقك ينفذ هذا العمل الفرعي؟ يرى العميل الاسم.",
        nameCrewConfirm: "حفظ",
        crewSaved: "تم حفظ الفريق",
        crewPlaceholder: "مثلًا: لي",
        subJobTitle: "ما المطلوب",
        brief: "الوصف (اختياري)",
        when: "متى",
        who: "من ينفذه",
        ourCrew: "فريقنا",
        crewName: "الفريق أو الشخص",
        clientContractorHint: "يستلم مقاول العميل العمل الفرعي وتذكيراته الخاصة.",
        addAnother: "إضافة والتالي",
      },
      report: {
        summary: "ملخص",
        full: "كامل",
        internal: "داخلي",
        forClient: "للعميل",
        forClientHint: "للعميل: بدون أسعار أو أسعار المقاولين.",
        partOf: "جزء من",
        checked: "تم التحقق",
        checkedBy: "تحقق منه {{name}}",
        started: "بدأ {{date}}",
        finished: "انتهى {{date}}",
        evidence_zero: "لا صور أو ملفات",
        evidence_one: "صورة أو ملف واحد",
        evidence_two: "صورتان أو ملفان",
        evidence_few: "{{count}} صور أو ملفات",
        evidence_many: "{{count}} صورة أو ملفًا",
        evidence_other: "{{count}} صورة أو ملف",
      },
      parts: {
        title: "قطع المهمة كاملة",
        missing_zero: "كل القطع متوفرة",
        missing_one: "قطعة واحدة غير متوفرة",
        missing_two: "قطعتان غير متوفرتين",
        missing_few: "{{count}} قطع غير متوفرة",
        missing_many: "{{count}} قطعة غير متوفرة",
        missing_other: "{{count}} قطعة غير متوفرة",
        allInHand: "كل القطع متوفرة",
        holdsUp: "تؤخر {{title}}",
      },
      plan: {
        asset: "الأصل",
        priority: "الأولوية",
        estimate: "التقدير",
        minutes: "المدة (بالدقائق)",
        waitsFor: "تنتظر",
        copyFrom: "نسخ من مهمة سابقة",
        addAnother: "إضافة ثم أخرى",
        create: "إنشاء مهمة فرعية",
        minutesOther: "مدة أخرى (بالدقائق)",
        done: "تم",
        addedCount_zero: "لم تُضف أي مهمة فرعية",
        addedCount_one: "أُضيفت مهمة فرعية واحدة",
        addedCount_two: "أُضيفت مهمتان فرعيتان",
        addedCount_few: "أُضيفت {{count}} مهام فرعية",
        addedCount_many: "أُضيفت {{count}} مهمة فرعية",
        addedCount_other: "أُضيفت {{count}} مهمة فرعية",
      },
      setup: {
        title: "من يدير هذه المهمة؟",
        hint: "يخطط المدير للمهام الفرعية، ويفحص كلًّا منها عند إنجازها، ويحافظ على سير المهمة.",
        me: "أنا",
        current: "{{name}} (المسؤول حاليًا)",
        someoneElse: "شخص آخر",
        keepOwnWork: "الإبقاء على العمل الموجود في هذه المهمة كمهمة فرعية 1",
        keepOwnWorkHint: "يحتفظ {{name}} بهذا العمل ويُطلب منه قبوله مجددًا كمهمة فرعية.",
        continue: "متابعة",
      },
    },
  },
detail: {
  handoffLock: {
    assignee: "تم تسليمها إلى {{name}}. تبقى المهمة كما حُددت؛ أعد إسنادها أو استرجعها لتغييرها.",
    quotes: "لدى المقاولين لتقديم عروض الأسعار. تبقى المهمة كما حُددت؛ اختر عرضًا أو أغلق الطلب لتغييرها.",
    changeTheWork: "تغيير المهمة",
    changing: "أنت تغيّر هذه المهمة. تم إبلاغ {{name}} وسيُطلب منه قبولها مرة أخرى عند الانتهاء.",
    doneChanging: "إنهاء التغيير",
    beingChangedBy: "{{name}} يغيّر هذه المهمة.",
    changedSinceAccepted: "تغيّرت هذه المهمة منذ قبولك لها. راجعها ثم اقبلها مرة أخرى.",
    revisedLength: "كم سيستغرق الأمر الآن؟ (بالدقائق)",
    opened: "فُتح التغيير. تم إبلاغ {{name}}.",
    closed: "أُغلق التغيير. طُلب من {{name}} قبول المهمة المعدّلة.",
  },
  report: {
    sharePrepared: "{{title}} جاهز.",
    shareSheetProviderHint: "اختر {{provider}} من قائمة المشاركة لحفظ هذا الملف.",
    share: {
      word: "مشاركة Word…",
      excel: "مشاركة Excel…",
      pdf: "مشاركة PDF…",
    },
    requestFailed: "لم ينجح ذلك. تحقق من اتصالك وحاول مرة أخرى.",
    exportFailed: "لم يُنشأ ملف التقرير. تحقق من اتصالك وحاول مرة أخرى.",
    exportShared: "التقرير جاهز. تم فتح قائمة المشاركة لحفظه أو إرساله.",
    exportDownloadStarted: "بدأ التنزيل. ستجده في التنزيلات.",
    exportTitle: "تقرير إنجاز المهمة ({{format}})",
    brandingSettings: "إعدادات العلامة التجارية",
    openJob: "فتح المهمة",
    linkCopied: "تم نسخ رابط المراجعة. الصقه في بريد أو رسالة.",
    shareToGetLink: "شارك التقرير للحصول على رابط",
    copyReviewLink: "نسخ رابط المراجعة",
    reviewRequested: "طُلبت المراجعة",
    sharedWith: "تمت المشاركة مع {{name}}",
    sharedReport: "تقرير الإنجاز المشترك",
    signedBy: "وقّعه {{name}}",
    forYourRecords: "هذا التقرير لسجلاتك.",
    alreadyClosed: "هذه المهمة مغلقة بالفعل.",
    sentBackMessage: "لقد أعدت العمل للتعديل. سيصلحه الفريق ويشارك التقرير مجدداً.",
    acceptedThanks: "لقد قبلت العمل. شكراً لك.",
    acceptedTeamCloses: "لقد قبلت العمل. سيغلق الفريق المهمة الآن.",
    sendBack: "إعادة للتعديل",
    acceptWork: "اعتماد",
    signOffPrompt: "راجع العمل أعلاه. إذا كنت راضياً، وقّع للاعتماد. وإلا اضغط إعادة للتعديل واذكر ما يحتاج إلى إصلاح.",
    decisionFailedBody: "تحقق من اتصالك وحاول مرة أخرى.",
    decisionFailedTitle: "لم يُرسل ردك",
    sentBackToast: "أُعيد. تم إبلاغ الفريق بما يحتاج إلى إصلاح.",
    acceptedToast: "شكراً. تم إبلاغ الفريق برضاك عن العمل.",
  },
  contextCard: {
    untitledJob: "مهمة بلا عنوان",
    created: "تم الإنشاء",
    createdBy: "أنشأها {{name}}",
    showFewerDetails: "إظهار تفاصيل أقل",
    showMoreDetails: "إظهار تفاصيل أكثر",
    fewerDetails: "تفاصيل أقل",
    moreDetails: "تفاصيل أكثر",
    dueAndScheduled: "مستحقة في {{due}} · مجدولة في {{scheduled}}",
    scheduled: "مجدولة في {{scheduled}}",
    due: "مستحقة في {{due}}",
    contacts: "جهات الاتصال",
    when: "متى",
    why: "لماذا",
    what: "ماذا",
    where: "أين",
    asset: "الأصل",
  },
  actionSheets: {
    failedToAskForPhotos: "لم يُرسل طلب الصور. تحقق من اتصالك وحاول مرة أخرى.",
    failedToSendBack: "لم تتم إعادة المهمة. تحقق من اتصالك وحاول مرة أخرى.",
    failedToDecline: "لم يتم رفض المهمة. تحقق من اتصالك وحاول مرة أخرى.",
    failedToCancel: "لم يتم إلغاء المهمة. تحقق من اتصالك وحاول مرة أخرى.",
    failedToPause: "لم يتم إيقاف المهمة مؤقتاً. تحقق من اتصالك وحاول مرة أخرى.",
    askedForPhotosUnnamed: "تم طلب صور إضافية. المهمة بانتظار مراجعتك.",
    askedForPhotos: "تم طلب صور إضافية من {{assignee}}. المهمة بانتظار مراجعتك.",
    sentBackUnnamed: "أُعيدت مع ملاحظتك. سيتم إبلاغك عند إعادة الإرسال.",
    sentBack: "أُعيدت إلى {{assignee}} مع ملاحظتك. سيتم إبلاغك عند إعادة الإرسال.",
    declined: "تم رفض المهمة. تم إبلاغ من عيّنها ويمكنه إعادة تعيينها.",
    cancelled: "تم إلغاء المهمة. تبقى في سجل المهام.",
    paused: "تم إيقاف المهمة مؤقتاً. اضغط استئناف عندما يمكن متابعة العمل.",
  },
  fieldAssist: {
    failedTitle: "تعذر تحسين النص",
    revert: "تراجع",
    discard: "تجاهل",
    accept: "قبول",
    rationale: "راجع الصياغة ثم اضغط قبول. يبقى نصك كما هو حتى تفعل.",
    draftTitle: "النص بعد التحسين",
    tidying: "جارٍ التحسين…",
    tidyUp: "حسّن بالذكاء الاصطناعي",
    stop: "إيقاف",
    dictate: "إملاء",
  },
  deliveryMode: {
    hint: {
      PRIVATE_QUOTES: "اطلب السعر من عدة مقاولين ثم اختر أحدهم.",
      DIRECT_CONTRACTOR: "أرسلها إلى مقاول تتعامل معه بالفعل.",
      INTERNAL: "يقوم أحد أفراد فريقك بالعمل.",
    },
    label: {
      PRIVATE_QUOTES: "طلب عروض أسعار",
      DIRECT_CONTRACTOR: "مقاول",
      INTERNAL: "فريقنا",
    },
    title: "من سينفذها؟",
  },
title: "مهمة",
actionModals: {
  send: "إرسال",
pauseReasons: {
waitingOnParts: "بانتظار القطع",
weatherDelay: "تأخير بسبب الطقس",
customerRequest: "طلب العميل",
other: "أخرى",
},
declineReasons: {
scheduleConflict: "تعارض الجدول الزمني",
noCapacity: "مشغول جدًا حاليًا",
wrongTrade: "يتطلب مهارة مختلفة",
needMoreInfo: "بحاجة إلى مزيد من المعلومات",
},
pauseTitle: "إيقاف أمر العمل مؤقتًا",
pauseReasonRequiredHint: "السبب مطلوب حتى يعرف الفريق سبب تعليق العمل.",
additionalDetailOptional: "تفاصيل إضافية (اختياري)",
additionalDetailPlaceholder: "مثال: يُتوقع توفرها في المخزون الأسبوع المقبل",
cancel: "إلغاء",
pause: "إيقاف مؤقت",
cancelJobTitle: "إلغاء المهمة",
cancelJobConfirm: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
reasonOptional: "السبب (اختياري)",
cancellationReasonPlaceholder: "على سبيل المثال. لم تعد هناك حاجة",
back: "رجوع",
yesCancel: "نعم، قم بالإلغاء",
declineJobTitle: "رفض المهمة",
declineReasonRequiredHint: "مطلوب سبب. سيتم إخطار الشخص الذي قام بتعيين أمر العمل هذا.",
reasonRequired: "السبب (مطلوب)",
declineReasonPlaceholder: "مثال: تعارض في المواعيد، ضغط العمل، التزام آخر",
additionalNoteOptional: "ملاحظة إضافية (اختياري)",
additionalNotePlaceholder: "أي تفاصيل لمن عيّن المهمة",
declineJob: "رفض",
reworkTitle: "إعادة للتعديل",
reworkHint: "اذكر ما يجب إصلاحه. سيرى منفذ العمل ملاحظتك ويعيد إرسالها للمراجعة بعد الإصلاح.",
reworkReasonPlaceholder: "على سبيل المثال. الصور مفقودة لـ X، والتكلفة الفعلية غير مكتملة، والملاحظات غير واضحة",
evidenceTitle: "طلب صور",
evidenceHint: "اذكر ما تحتاج إلى رؤيته. تبقى المهمة بانتظار مراجعتك أثناء إضافة الصور.",
evidenceReasonPlaceholder: "مثال: صورة واضحة لمنطقة التثبيت السفلية",
requestEvidence: "طلب صور",
rework: "إعادة للتعديل",
},
detailScreen: {
  followUpNeeded: "تلزم متابعة: {{reason}}.",
  receiptsAndInvoices: "الإيصالات والفواتير",
  verifyInTheirPlace: "التحقق نيابة عنه",
  completedSolo: "تم. أُغلقت المهمة.",
  assignedInviteFailedBody: "المهمة له، لكن تعذر إرسال بريد الدعوة. أبلغه بنفسك.",
  assignedInviteFailedTitle: "تم التعيين، لكن لم يُرسل البريد",
  noTeamBody: "تعذر معرفة الفريق الذي تتبع له هذه المهمة، لذلك لم تتم دعوة المقاول. تحقق من اتصالك وحاول مرة أخرى.",
  noTeamTitle: "لا يوجد فريق لهذه المهمة",
  failedToResume: "لم تُستأنف المهمة. تحقق من اتصالك وحاول مرة أخرى.",
  failedToAssign: "لم يتم تعيين المهمة. تحقق من اتصالك وحاول مرة أخرى.",
addTitleFirst: "أضف عنوانًا أولاً",
addDescriptionFirst: "أضف وصفًا أولاً",
typeOrDictateTitleHint: "اكتب أو أملي عنوانًا قصيرًا، ثم استخدم التحسين باستخدام الذكاء الاصطناعي.",
typeOrDictateDescriptionHint: "اكتب وصفًا أو أمليه، ثم استخدم التحسين باستخدام الذكاء الاصطناعي.",
unableToImproveText: "تعذر تحسين النص",
tryAgain: "حاول مرة أخرى.",
verifiedInPlaceOf: "تم التحقق بدلاً من {{name}}",
couldNotVerify: "تعذر التحقق",
tryAgainShort: "حاول مرة أخرى.",
stageAdded: "تمت إضافة {{stage}}",
couldNotAddCheck: "تعذّرت إضافة هذا الفحص",
precheckFirst: "الفحص المسبق أولاً",
notNow: "ليس الآن",
runStage: "إجراء {{stage}}",
couldNotStartJob: "تعذر بدء أمر العمل هذا",
movedToStatus: "نُقلت إلى {{status}}",
couldNotMoveJob: "تعذر نقل أمر العمل هذا",
acceptedOn: "تم القبول في",
rejectedOn: "تم الرفض في",
sentToLine: "تم الإرسال إلى {{names}}.",
missingEmailForLine: "البريد الإلكتروني مفقود لـ {{names}}.",
noInvoiceOrReceiptAttached: "لم تُرفق أي ملفات فاتورة أو إيصال.",
completionSentTitle: "تم إرسال الإكمال",
completionEmailSent: "تم إرسال بريد الإكمال.",
emailNotSentTitle: "لم يتم إرسال البريد الإلكتروني",
visitConfirmed: "تم تأكيد الزيارة",
awaitingVisitConfirmation: "بانتظار تأكيد الزيارة",
recipientLine: "{{label}}: {{name}}",
recipientEmailSuffix: " ({{email}})",
requesterDeliveryLine: "مقدم الطلب: {{status}}",
assigneeDeliveryLine: "المُعيَّن: {{status}}",
helpMeWithJobDraft: "ساعدني في هذه المهمة: {{title}}. اقترح الخطوات التالية أو مسودة ملاحظة الإغلاق.",
currentJobFallback: "أمر العمل الحالي",
captureNotSavedTitle: "لم يُحفظ الالتقاط",
captureNotFoundBody: "تعذر العثور على هذا الالتقاط. يرجى التقاطها مرة أخرى.",
captureMismatchBody: "لا يتطابق هذا الالتقاط مع أمر العمل الحالي.",
noPhotoWasCaptured: "لم يتم التقاط أي صورة.",
mustBeSignedInToSavePhotos: "يجب عليك تسجيل الدخول لحفظ الصور.",
capturedFromHome: "تم الالتقاط من الشاشة الرئيسية",
photoAddedToActivity: "تمت إضافة الصورة إلى نشاط المهمة",
noDictationTextCaptured: "لم يُلتقط أي نص إملاء.",
jobUpdateAdded: "تم نشر التحديث. يراه كل من يعمل على هذه المهمة في النشاط.",
noNoteTextCaptured: "لم يتم التقاط نص الملاحظة.",
activityNoteAdded: "تمت إضافة الملاحظة. يراها كل من يعمل على هذه المهمة في النشاط.",
readingCostNotePrefix: "ملاحظة القراءة/التكلفة: {{value}}",
readingAddedToActivity: "تمت إضافة القراءة إلى نشاط أمر العمل",
captureNotSupportedTitle: "الالتقاط غير مدعوم",
qrScanNotSavedBody: "تتم معالجة مسح QR من الماسح الضوئي، ولا يُحفظ في نشاط المهمة.",
captureModeNotSupported: "وضع الالتقاط هذا غير مدعوم لأوامر العمل.",
skillsUnavailableTitle: "المهارات غير متاحة",
skillsUnavailableBody: "تعذر تحميل المهارات الآن. يمكنك إعادة المحاولة في المنتقي.",
followOnTitleSuffix: "{{title}} (متابعة)",
workFallback: "العمل",
revisedWorkSubmitted: "أُرسل العمل المعدّل للمراجعة. تم إبلاغ المراجع.",
completionSubmittedAwaitingVerification: "أُرسلت للمراجعة. يتحقق المراجع منها، ثم يعتمدها أو يعيدها.",
unableToCleanUp: "تعذر التنظيف",
changeApproved: "تمت الموافقة على التغيير. تعرض المهمة الآن التاريخ أو الشخص الجديد، وتم إبلاغ صاحب الطلب.",
requestRejected: "تم رفض الطلب. تبقى المهمة كما هي، وتم إبلاغ صاحب الطلب.",
error: "حدث خطأ ما",
couldNotRecordDecision: "لم يتم حفظ قرارك. تحقق من اتصالك وحاول مرة أخرى.",
savedOnDeviceWillSend: "تم الحفظ على هذا الجهاز — سيُرسل عند عودة الاتصال بالإنترنت",
requestSent: "تم إرسال الطلب. لن يتغير شيء حتى يوافق عليه المسؤول، وسيتم إبلاغك.",
couldNotSendRequest: "لم يتم إرسال طلبك. تحقق من اتصالك وحاول مرة أخرى.",
outcomeLinePrefix: "النتيجة: {{value}}",
meterReadingTitle: "قراءة العداد",
enterMeterReadingBody: "أدخل قراءة العداد كرقم أو اتركها فارغة.",
readingLowerThanCurrentBody: "{{amount}} أقل من {{current}} الحالي. تحقق من الرقم — أو سجل تصحيحًا من بطاقة صيانة الأصل.",
readingLowerThanEarlierBody: "هذه القراءة أقل من القراءة السابقة. تحقق من الرقم.",
readingAlreadyRecordedAfterBody: "تم بالفعل تسجيل قراءة {{current}} بعد هذه القراءة. تحقق من الرقم.",
laterReadingAlreadyRecordedBody: "تم بالفعل تسجيل قراءة لاحقة. تحقق من الرقم.",
meterReadsInUnitBody: "يقيس هذا العداد بوحدة {{unit}}.",
completionSubmittedAwaitingOwnerVerification: "أُرسلت للمراجعة. يتحقق منشئ المهمة منها، ثم يعتمدها أو يعيدها.",
failedToComplete: "لم يتم إرسال المهمة. ملاحظاتك وصورك محفوظة. تحقق من اتصالك وحاول مرة أخرى.",
completeRequiredDetailsFirstTitle: "أكمل التفاصيل المطلوبة أولاً",
pleaseFixBeforeSubmitting: "يرجى إصلاح هذه الأخطاء قبل إرسال الإكمال:\n{{list}}",
goToCompletion: "انتقل إلى الاكتمال",
cancel: "إلغاء",
costBreakdownActionUnavailable: "إجراء تفصيل التكلفة غير متاح. يرجى تحديث التطبيق.",
jobAccepted: "تم قبول المهمة. اضغط بدء عندما تبدأ العمل.",
failedToAccept: "لم يتم قبول المهمة. تحقق من اتصالك وحاول مرة أخرى.",
workApproved: "تم اعتماد العمل. أُغلقت المهمة وتم تحديث سجل الأصل.",
requireSignOffForJobsThisSize: "اشتراط الاعتماد للمهام بهذا الحجم",
failedToApprove: "لم يتم اعتماد العمل. تحقق من اتصالك وحاول مرة أخرى.",
cannotCreateCertificateTitle: "لا يمكن إنشاء الشهادة",
cannotCreateCertificateBody: "أمر العمل هذا غير مرتبط بأصل.",
certificateCreatedTitle: "تم إنشاء الشهادة",
certificateCreatedBody: "الشهادة مرتبطة بأمر العمل والأصل هذا.",
couldNotCreateCertificate: "تعذر إنشاء الشهادة.",
deleteJobTitle: "حذف المهمة",
actionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
delete: "حذف",
jobDeleted: "تم حذف أمر العمل",
failedToDelete: "لم يتم حذف المهمة. تحقق من اتصالك وحاول مرة أخرى.",
titleRequiredTitle: "العنوان مطلوب",
enterFollowOnTitleBody: "أدخل عنواناً لمهمة المتابعة.",
skillsRequiredTitle: "المهارات مطلوبة",
selectRequiredSkillBody: "اختر مهارة واحدة على الأقل لمهمة المتابعة هذه.",
followUpJobCreated: "تم إنشاء مهمة متابعة. تجدها في العمل وهي مرتبطة بهذه المهمة.",
followUpCreatedTitle: "تم إنشاء المتابعة",
followUpCreatedBody: "تم إنشاء أمر عمل المتابعة المرتبط. يمكنك فتحه من الاكتمال أو الاستمرار في إكمال أمر العمل هذا.",
failedToCreateFollowOn: "لم يتم إنشاء مهمة المتابعة. تحقق من اتصالك وحاول مرة أخرى.",
failedToApproveFollowOn: "لم تتم الموافقة على المتابعة. تحقق من اتصالك وحاول مرة أخرى.",
notApproved: "غير معتمد",
followUpNotApproved: "تم رفض المتابعة. أُلغيت، وسببك مسجل في سجلها.",
failedToRejectFollowOn: "لم يتم رفض المتابعة. تحقق من اتصالك وحاول مرة أخرى.",
linkAContact: "ربط جهة اتصال",
requesterFallback: "مُقدّم الطلب",
draftCloseout: "صياغة الملاحظة بالذكاء الاصطناعي",
draftInvoice: "مسودة الفاتورة",
loadingJobDetails: "جارٍ تحميل تفاصيل أمر العمل...",
unableToLoadJob: "غير قادر على تحميل أمر العمل",
jobNotFound: "لم يتم العثور على أمر العمل",
ownerFallback: "المالك",
parentJobApproverFallback: "معتمد المهمة الأصلية",
assigneeFallback: "المكلَّف",
everyoneDeclinedYouInviteMore: "رفض جميع المدعوين — أنت تدعو المزيد",
everyoneDeclined: "رفض جميع المدعوين",
contractorsSubmitQuotes: "يقدّم المقاولون عروض الأسعار",
youRequestQuotes: "أنت تطلب عروض أسعار",
ownerRequestsQuotes: "يطلب المالك عروض الأسعار",
youPickAContractor: "أنت تختار مقاولاً",
ownerPicksAContractor: "يختار المالك مقاولاً",
youAssignTheJob: "أنت تُسند أمر العمل",
ownerAssignsTheJob: "المالك يُسند أمر العمل",
requesterConfirmsFixNamed: "{{name}} يؤكد الإصلاح",
assignedPrefix: "تم الإسناد",
assignedToSuffix: " إلى {{name}}",
resolveBeforeSubmitting: "قم بحل هذه المشكلة قبل إرسال الإكمال.",
tightenEvidenceCostsNotes: "حسّن الأدلة أو التكاليف أو الملاحظات لتكون الموافقة سهلة ومباشرة.",
captureFollowUpWorkHint: "سجّل أعمال المتابعة أو مهمة مرتبطة حتى لا يفوتك شيء.",
noScheduledStartExplanation: "أمر العمل هذا ليس له بداية مجدولة.",
setScheduleRecommendedAction: "لا يوجد موعد بعد. اختر موعداً أو عيّنها حتى لا تتأخر.",
pastScheduledStartExplanation: "لقد تجاوز أمر العمل هذا تاريخ البدء أو الاستحقاق المقرر.",
updateScheduleRecommendedAction: "تجاوزت موعدها. أعد جدولتها أو أبلغ مقدم الطلب.",
completionChecksClear: "لا توجد مشكلات في فحوصات الإكمال للسجل الحالي.",
keepUpdatesAlignedAction: "حافظ على اتساق التحديثات والأدلة والتكاليف والملاحظات مع تقدم العمل.",
reviewCompletion: "مراجعة الإكمال",
openCompletion: "فتح الإكمال",
setSchedule: "ضبط الجدول",
updateSchedule: "تحديث الجدول",
inspectionLine: "الفحص: {{label}}",
openRelatedAsset: "فتح الأصل المرتبط",
jobInsight: "رؤية أمر العمل",
insightWarnings_zero: "لا تحذيرات",
insightWarnings_one: "تحذير واحد",
insightWarnings_two: "تحذيران",
insightWarnings_few: "{{count}} تحذيرات",
insightWarnings_many: "{{count}} تحذيرًا",
insightWarnings_other: "{{count}} تحذير",
insightBlockers_zero: "لا عوائق",
insightBlockers_one: "عائق واحد",
insightBlockers_two: "عائقان",
insightBlockers_few: "{{count}} عوائق",
insightBlockers_many: "{{count}} عائقًا",
insightBlockers_other: "{{count}} عائق",
insightSummaryLine: "{{warnings}}، {{blockers}}",
followUp: "متابعة",
suggested: "مقترح",
thisJobsChecksAndStatus: "فحوصات أمر العمل هذا وحالته",
contractorWorkspace: "مساحة المقاول",
nextLine: "التالي: {{value}}",
statusUnavailable: "الحالة غير متاحة",
updatesNew: "التحديثات · جديد",
updates: "التحديثات",
hideStatusHistory: "إخفاء سجل الحالة",
statusHistory: "سجل الحالة",
hideCompletionAndCosts: "إخفاء الإكمال والتكاليف",
completionAndCosts: "الإكمال والتكاليف",
cancelJob: "إلغاء المهمة",
deleteJobAction: "حذف المهمة",
moreJobOptions: "المزيد من خيارات أمر العمل",
approveCompletion: "تحقق",
cantDoThis: "رفض",
assignDirectly: "قم بالتعيين مباشرة",
jobAssistant: "مساعد أمر العمل",
readOnly: "للقراءة فقط",
jobCreated: "تم إنشاء المهمة",
suggestedNextStepLine: "الخطوة التالية المقترحة: {{step}}.",
trackProgressHint: "تتبع التقدم في النشاط، ثم أغلقه عند اكتمال العمل.",
dismissJobCreatedMessage: "إغلاق رسالة إنشاء المهمة",
gotIt: "فهمت",
atAGlance: "في لمحة",
status: "الحالة",
next: "التالي",
visit: "الزيارة",
cost: "التكلفة",
openAssetLabel: "فتح الأصل {{name}}",
relatedRecords: "السجلات ذات الصلة",
couldNotSaveJobDetails: "تعذر حفظ تفاصيل أمر العمل.",
jobOptions: "خيارات أمر العمل",
linkContactToJob: "ربط جهة الاتصال بأمر العمل",
relationship: "العلاقة",
couldNotAddExtractedLineItem: "تعذر إضافة البند المستخرج",
jobFallback: "مهمة",
signInRequiredToUpload: "يلزم تسجيل الدخول للتحميل.",
reopenJob: "إعادة فتح أمر العمل",
startJob: "بدء المهمة",
acceptJob: "قبول أمر العمل",
workPath: "من ينفذها",
overdue: "متأخر",
unscheduled: "غير مُجدوَل",
onSiteLine: "في الموقع: {{location}}",
fromInspectionLine: "من الفحص — {{label}}",
followOnOfLine: "متابعة لـ — {{title}}",
parentJobFallback: "أمر العمل الأصلي",
requestedByLine: "طلبه — {{name}}",
roleAndNameLine: "{{role}} — {{name}}",
jobAssigned: "تم تعيين المهمة. تم إبلاغ الشخص وعليه قبولها.",
contractorAssigned: "تم تعيين المقاول. أُرسلت إليه دعوة وعليه قبول المهمة.",
jobResumed: "استؤنفت المهمة. اضغط إكمال عند الانتهاء من العمل.",
},
closeout: {
  extractLineItems: "قراءة البنود من الفاتورة",
  extractingLineItems: "جارٍ قراءة الفاتورة…",
  generatingInvoice: "جارٍ إنشاء الفاتورة…",
  materialsSummary: "أضف القطع والمواد. سنجمعها للفاتورة.",
followUpTitle: "متابعة",
suggestFollowUpWork: "اقتراح عمل متابعة",
suggestNextSteps: "اقترح الخطوات التالية",
apply: "تطبيق",
skillLine: "المهارة: {{value}}",
riskLine: "المخاطر: {{value}}",
costsAndInvoicesIncluded: ". التكاليف والفواتير مُدرجة أدناه.",
completedThisLine: "أكمل {{name}} هذا {{when}}. ",
requesterConfirmsFix: "يؤكد مقدم الطلب الإصلاح",
ownerFallback: "المالك",
addDetailsBeforeSubmitting: "أضف تفاصيل الإكمال قبل الإرسال.",
submitCompletion: "إرسال الإنجاز",
completion: "الإكمال",
followUpJobsTitle: "مهام المتابعة",
followUpJobsSummary: "أضف مهام المتابعة أو راجعها بعد جاهزية ملاحظة الإنجاز.",
proposeFollowOnJob: "اقتراح مهمة متابعة",
linkedHeldForApproval: "مرتبط بأمر العمل هذا وينتظر الموافقة عليه.",
proposeMoreWork: "اقتراح عمل إضافي",
proposeMoreWorkHint: "يصل إليهم كطلب. هم يقررون، وترى الرد هنا.",
proposalSent: "تم إرسال الاقتراح",
proposalWaiting: "بانتظار القرار",
proposalApproved: "تمت الموافقة",
proposalBecameJob: "أصبح مهمة",
proposalNotTaken: "لم يُعتمد",
followUpJobsLinkedTitle: "تم ربط مهام المتابعة",
createdNowPrefix: "أُنشئ الآن: ",
followUpPrefix: "متابعة: ",
pendingApprovalSuffix: " · بانتظار الموافقة",
followUpLinkedContinueBody: "تم ربط مهمة المتابعة. يمكنك المتابعة وإكمال هذه المهمة.",
requiredBeforeSubmit: "مطلوب قبل الإرسال",
beforeYouSubmit: "قبل الإرسال",
workCompleted: "العمل المكتمل",
workCompletedPlaceholder: "ما العمل الذي تم إنجازه؟",
rewriting: "جارٍ التحسين…",
rewrite: "حسّن بالذكاء الاصطناعي",
revert: "تراجع",
actualCost: "التكلفة الفعلية",
leaveBlankToRecordAsZero: "اتركه فارغًا للتسجيل كـ 0. أدخل المبلغ الكامل لأمر العمل هذا إذا كان هناك رسوم.",
fromCostBreakdownReadOnly: "من تفصيل التكلفة (للقراءة فقط)",
verifiedLine: "تم التحقق في {{date}} | التكلفة الفعلية {{amount}}",
costsLockedPendingVerification: "التكاليف مقفلة بينما ينتظر الإكمال التحقق.",
quickFinishHint: "إنهاء سريع: أضف تفاصيل الإكمال والتكلفة الفعلية، ثم أرسل.",
costSummary: "ملخص التكلفة",
estimateLine: "التقدير: {{value}}",
actualTotalLine: "الإجمالي الفعلي: {{value}}",
vsEstimateLine: "مقابل التقدير: {{value}}",
actualCostHint: "يجب أن تتضمن التكلفة الفعلية كافة الرسوم الخاصة بأمر العمل هذا.",
optionalBreakdownHint: "اختياري: قم بإضافة تفاصيل تفصيلية فقط إذا لزم الأمر.",
detailedCostBreakdown: "توزيع مفصل للتكلفة",
detailedCostBreakdownSummary: "تعتبر رسوم المواد والعمالة والضرائب وغيرها من الرسوم اختيارية ما لم يكن أمر العمل هذا يحتاج إلى تكاليف مفصلة.",
optionalDetailedCostBreakdown: "توزيع تفصيلي للتكلفة اختياري",
materialsBreakdownOptional: "توزيع المواد (اختياري)",
lineItemsOptional: "البنود (اختياري)",
failedToAddLineItem: "لم يُضف البند. تحقق من اتصالك وحاول مرة أخرى.",
add: "إضافة",
itemName: "اسم العنصر",
removeItemTitle: "إزالة العنصر",
removeItemBody: "هل تريد إزالة هذا البند؟",
cancel: "إلغاء",
remove: "إزالة",
error: "حدث خطأ ما",
failedToUpdateLineItem: "لم يُحفظ البند. تحقق من اتصالك وحاول مرة أخرى.",
failedToRemoveLineItem: "لم يُحذف البند. تحقق من اتصالك وحاول مرة أخرى.",
failedToUpdateQty: "لم تُحفظ الكمية. تحقق من اتصالك وحاول مرة أخرى.",
failedToUpdateUnitCost: "لم يُحفظ سعر الوحدة. تحقق من اتصالك وحاول مرة أخرى.",
failedToUpdateTotalCost: "لم يُحفظ الإجمالي. تحقق من اتصالك وحاول مرة أخرى.",
quantityForItem: "الكمية لـ {{name}}",
itemFallback: "عنصر",
qty: "الكمية",
unitCostForItem: "تكلفة الوحدة لـ {{name}}",
unit: "الوحدة",
totalForItem: "الإجمالي لـ {{name}}",
total: "الإجمالي",
fromQtyTimesUnit: "من الكمية × الوحدة: {{amount}}",
manualTotalOverrideSuffix: " (عدّلت الإجمالي)",
useCalculatedTotal: "استخدم الإجمالي المحسوب",
materialsSubtotal: "المجموع الفرعي للمواد: {{amount}}",
labourTaxOtherOptional: "العمالة والضرائب والرسوم الأخرى (اختياري)",
costBreakdownOptional: "تفصيل التكلفة (اختياري)",
failedToRemoveBreakdown: "لم يُحذف التفصيل. تحقق من اتصالك وحاول مرة أخرى.",
failedToAddCostBreakdown: "لم يُضف التفصيل. تحقق من اتصالك وحاول مرة أخرى.",
removeBreakdown: "إزالة التفصيل",
addBreakdown: "إضافة تفاصيل",
labourExTax: "العمالة (باستثناء الضرائب)",
taxEntry: "إدخال الضريبة",
amount: "المبلغ",
percentOfLabour: "نسبة العمالة",
taxAmount: "مبلغ الضريبة",
taxRatePercentOfLabour: "معدل الضريبة (% من العمالة)",
taxRateLine: "معدل الضريبة: {{pct}}%",
otherCharges: "رسوم أخرى",
otherChargeLabel: "تسمية الرسوم الأخرى {{n}}",
label: "التسمية",
otherChargeAmount: "مبلغ الرسوم الأخرى {{n}}",
totalBreakdownLine: "الإجمالي = المواد {{materials}} + العمالة {{labour}} + الضريبة {{tax}} + {{other}} أخرى",
totalLine: "الإجمالي: {{amount}}",
invoicesAndCloseoutEmail: "الفواتير وبريد التقرير",
invoicesAndCloseoutEmailSummary: "أرفق الفواتير، أو أرسل التقرير بعد جاهزية ملاحظة الإنجاز.",
invoiceLabel: "الفاتورة (PDF، صورة، أو Word)",
generateInvoiceWithAi: "قم بإنشاء فاتورة باستخدام الذكاء الاصطناعي",
reviewInvoiceDraft: "مراجعة مسودة الفاتورة",
signInRequired: "تسجيل الدخول مطلوب",
emailCloseoutRecipients: "أرسل التقرير إلى مقدم الطلب",
emailAlwaysIncludesSummary: "يتضمن البريد ملخصاً للعمل. تُرفق الفواتير والإيصالات والصور إن وُجدت.",
},
assetContextSection: {
asset: "أصل",
viewAssetKnowledgeBase: "عرض قاعدة معارف الأصول",
viewAssetKnowledge: "عرض معرفة الأصول",
noAssetLinked: "لا يوجد أصل مرتبط بأمر العمل هذا.",
overview: "نظرة عامة",
location: "الموقع",
fromLinkedAsset: "من الأصل المرتبط",
aboutThisJob: "حول أمر العمل هذا",
approverLine: "المعتمد: {{name}}",
approverFallback: "-",
sectionOfInterest: "القسم المعني",
viewSourceInspection: "عرض الفحص الأصلي",
fromInspection: "من الفحص",
video: "فيديو",
photos: "الصور",
linkedRecords: "السجلات المرتبطة",
fromRequestLine: "من الطلب: {{id}}",
followsFromLine: "ناتجة عن: {{title}}",
parentJobFallback: "أمر العمل الأصلي",
followOnLine: "متابعة: {{title}}",
sourceLine: "المصدر: {{label}}",
groupedScheduleLine_one: "يمكن جدولة أمر عمل نشط آخر واحد على هذا الأصل معه.",
groupedScheduleLine_other: "يمكن جدولة {{count}} أمر عمل نشط آخر على هذا الأصل معًا.",
groupedScheduleLine_zero: "لا أوامر عمل نشطة أخرى على هذا الأصل.",
groupedScheduleLine_two: "يمكن جدولة أمري عمل نشطين آخرين على هذا الأصل معًا.",
groupedScheduleLine_few: "يمكن جدولة {{count}} أوامر عمل نشطة أخرى على هذا الأصل معًا.",
groupedScheduleLine_many: "يمكن جدولة {{count}} أمرَ عمل نشطًا آخر على هذا الأصل معًا.",
},
scheduleSection: {
rescheduleTo: "إعادة الجدولة إلى",
scheduleFor: "الجدولة في",
today: "اليوم",
tomorrow: "غدا",
nextWeek: "الأسبوع التالي",
custom: "مخصص",
selectDate: "اختر التاريخ",
time: "الوقت",
selectTime: "حدد الوقت",
duration: "المدة",
plannedLine: "المخطط له: {{value}}",
reasonOptional: "السبب (اختياري)",
reasonForReschedulePlaceholder: "سبب إعادة الجدولة",
scheduleTogetherOptional: "الجدولة معًا (اختياري)",
groupSameAssetHint: "اجمع أعمال الأصل نفسه لتقليل الزيارات المتكررة.",
unscheduledSuffix: " | غير مجدول",
cancel: "إلغاء",
reschedule: "إعادة الجدولة",
schedule: "الجدولة",
},
deliveryModeSheet: {
cancel: "إلغاء",
saving: "جارٍ الحفظ...",
save: "حفظ",
},
mediaViewer: {
couldNotLoadImage: "تعذر تحميل الصورة",
imageUnavailable: "ربما تم نقل الصورة أو أنها غير متوفرة.",
},
handoffRecommendationPanel: {
  evidence: {
    beforeAfter: "عند الانتهاء: صور قبل وبعد وملاحظة قصيرة.",
    replacementPhotos: "عند الانتهاء: صور قبل وبعد وما تم تركيبه.",
    checklistPhotos: "عند الانتهاء: قائمة التحقق المكتملة وصور لكل ما لم يجتز الفحص.",
  },
  reason: {
    originKept: {
      finding: "تظل مرتبطة بملاحظة الفحص.",
      inspection: "تظل مرتبطة بالفحص.",
      request: "تظل مرتبطة بالطلب.",
      asset: "تظل مرتبطة بالأصل.",
    },
    noOrigin: "راجع التفاصيل أعلاه قبل إنشائها.",
    skillsUnconfirmed: "لم تُضف مهارات بعد. أضفها إذا كانت هناك حاجة إلى حرفة معينة.",
    skillsCarried_many: "المهمة تتضمن {{count}} مهارةً بالفعل.",
    skillsCarried_few: "المهمة تتضمن {{count}} مهارات بالفعل.",
    skillsCarried_two: "المهمة تتضمن {{count}} مهارات بالفعل.",
    skillsCarried_zero: "المهمة تتضمن {{count}} مهارات بالفعل.",
    skillsCarried_other: "المهمة تتضمن {{count}} مهارة بالفعل.",
    skillsCarried_one: "المهمة تتضمن {{count}} مهارة بالفعل.",
    dueByPriority_many: "الأولوية {{priority}}: احرص على الإنجاز خلال {{count}} يومًا.",
    dueByPriority_few: "الأولوية {{priority}}: احرص على الإنجاز خلال {{count}} أيام.",
    dueByPriority_two: "الأولوية {{priority}}: احرص على الإنجاز خلال {{count}} أيام.",
    dueByPriority_zero: "الأولوية {{priority}}: احرص على الإنجاز خلال {{count}} أيام.",
    dueByPriority_other: "الأولوية {{priority}}: احرص على الإنجاز خلال {{count}} يوم.",
    dueByPriority_one: "الأولوية {{priority}}: احرص على الإنجاز خلال {{count}} يوم.",
    contractorNoInternal: "لا أحد متاح في فريقك: اختر مقاولاً.",
    contractorFromSourceJob: "تعود إلى المقاول الذي نفّذ المهمة التي نشأت منها.",
    contractorCritical: "لا أحد متاح في فريقك والأمر عاجل: أرسلها مباشرة إلى مقاول تثق به.",
    quotesHighValue: "لا أحد متاح في فريقك والعمل مكلف: قارن بين عدة عروض أسعار أولاً.",
    internalAvailableUnnamed: "يستطيع أحد أفراد فريقك تنفيذها.",
    internalAvailable: "يستطيع {{name}} من فريقك تنفيذها.",
  },
recommendedHandoff: "مقترح",
titleLine: "{{mode}} · مستحق في {{days}} {{dayWord}}",
dayWord_one: "يوم",
dayWord_other: "يوم",
applied: "تم التطبيق",
apply: "استخدم هذا الاقتراح",
whyRecommendedTitle: "لماذا؟",
priorityOverrideLine: "الأولوية: {{priority}}. غيّرها من إضافة سياق إذا كانت غير صحيحة.",
planningRangeLine: "نطاق التخطيط {{min}}–{{max}}؛ تأكيد قبل التكليف.",
dayWord_zero: "أيام",
dayWord_two: "يومان",
dayWord_few: "أيام",
dayWord_many: "يومًا",
},
statusInsight: {
theReviewer: "المراجع",
reworkRequested: "أُعيدت للتعديل",
workPath: "من ينفذها",
updating: "جارٍ التحديث...",
internal: "داخلي",
recipientView: "عرض المستلم",
recipientViewBody: "يمكنك مراجعة أمر العمل هذا. يقتصر التحرير على ما يسمح به دورك.",
execution: "تنفيذ العمل",
executionBody: "عند الانتهاء من العمل، اضغط إكمال لإضافة ملاحظتك وصورك وتكاليفك.",
nextStep: "الخطوة التالية",
nextLine: "التالي: {{actor}}",
followOnApproval: "اعتماد المتابعة",
followOnApprovalBody: "اعتمد مهمة المتابعة هذه حتى يمكن تعيينها وتحديد موعدها.",
awaitingFollowOnApproval: "بانتظار الاعتماد",
waitingForApproverBody: "مهمة المتابعة هذه بانتظار الاعتماد. لا يمكن تعيينها أو تحديد موعدها قبل ذلك.",
waitingForParentApproverBody: "لا يمكن إسناد أمر العمل هذا أو جدولته حتى يقرر معتمد أمر العمل الأصلي ذلك.",
overdue: "متأخر",
unscheduled: "غير مُجدوَل",
},
activitySection: {
  assistantChange: "تم التغيير عبر المساعد",
  assistantUndone: "تم التراجع عن تغيير المساعد",
  playVideo: "تشغيل الفيديو",
  openPhoto: "فتح الصورة",
statusNone: "بلا",
systemActor: "النظام",
userFallback: "أحد أعضاء الفريق",
taskTimeline: "الجدول الزمني للمهمة",
purposeHint: "الحالة والرسائل والأدلة والإجراءات في مساحة عمل زمنية واحدة.",
noStatusEvents: "لا توجد أحداث حالة حتى الآن.",
recentEvidence: "الأدلة الحديثة",
noMessagesOrEvidence: "لا توجد رسائل أو أدلة حتى الآن.",
openFullTimeline: "فتح الجدول الزمني الكامل>",
},
assignmentSection: {
contacts: "جهات الاتصال",
noContactsLinked: "لا توجد جهات اتصال مرتبطة.",
contactFallback: "جهة اتصال",
couldNotUnlinkTitle: "تعذر إلغاء ربط جهة الاتصال",
tryAgain: "حاول مرة أخرى.",
linkContact: "ربط جهة اتصال",
assignmentAndSchedule: "التعيين والجدول الزمني",
declinedSuffix: "{{name}} (اعتذر)",
awaitingAssignee: "في انتظار المحال إليه",
requesterLine: "مقدم الطلب: {{name}}",
requesterEmailSuffix: " ({{email}})",
notLinkedYet: "لم يتم ربطه بعد",
scheduledLine: "مجدول: {{value}}",
notScheduledYet: "لم يُجدول بعد",
closeoutRecipientsFallback: "بعد تعيين شخص ما، سنعرض من يستلم التقرير النهائي.",
completionEmailLine: "البريد الإلكتروني للإكمال: {{value}}",
rejected: "مرفوضة",
changeAssignee: "تغيير المكلف",
change: "تغيير",
reassign: "إعادة التكليف",
contractorType: "متعهد",
internalTeamType: "الفريق الداخلي",
reason: "السبب",
invitedAcceptedDeclinedLine: "مدعو: {{total}} | مقبول: {{accepted}} | مرفوض: {{declined}}",
pendingSuffix: " | في انتظار الرد: {{pending}}",
quoteRequestLine: "طلب عرض أسعار: {{status}}",
quoteInvitedSubmittedDeclinedLine: "{{invited}} مدعو | تم إرسال {{submitted}} | رفض {{declined}}",
quoteCountLine_zero: "{{count}} عرض سعر: {{open}} مفتوح | تم قبول {{accepted}} | تم رفض {{rejected}}",
quoteCountLine_one: "عرض سعر واحد: {{open}} مفتوح | تم قبول {{accepted}} | تم رفض {{rejected}}",
quoteCountLine_two: "عرضا سعر: {{open}} مفتوح | تم قبول {{accepted}} | تم رفض {{rejected}}",
quoteCountLine_few: "{{count}} عروض أسعار: {{open}} مفتوح | تم قبول {{accepted}} | تم رفض {{rejected}}",
quoteCountLine_many: "{{count}} عرضَ سعر: {{open}} مفتوح | تم قبول {{accepted}} | تم رفض {{rejected}}",
quoteCountLine_other: "{{count}} عرض سعر: {{open}} مفتوح | تم قبول {{accepted}} | تم رفض {{rejected}}",
awardedToLine: "مُنحت إلى: {{name}}",
execution: "العمل",
started: "بدأت",
completed: "مكتمل",
actualDuration: "المدة الفعلية",
elapsed: "المدة المنقضية",
confirmed: "تم التأكيد",
confirmedBySuffix: " · {{name}}",
verified: "موثقة",
continueJob: "متابعة أمر العمل",
continueJobHint: "أضف تفاصيل الإكمال والتكلفة الفعلية قبل الإرسال.",
completion: "الإكمال",
},
statusGuidance: {
title: "الحالة والتوجيه",
},
invoicePreview: {
title: "مراجعة مسودة فاتورة الذكاء الاصطناعي",
hint: "أكِّد التفاصيل، ثم أرفق ملف PDF الذي تم إنشاؤه بأمر العمل هذا.",
titleAndNumber: "{{title}} - {{number}}",
issueDate: "تاريخ الإصدار: {{date}}",
dueDateSuffix: " | الاستحقاق: {{date}}",
from: "من",
billTo: "فاتورة إلى",
lineItems: "البنود",
lineItemLine: "{{description}} x{{quantity}} - {{amount}}",
total: "الإجمالي: {{amount}}",
noDraftFound: "لم يتم العثور على مسودة. قم بإنشاء مسودة فاتورة أولاً.",
back: "رجوع",
attaching: "جارٍ الإرفاق…",
attachPdf: "قم بإرفاق PDF",
},
followOnModals: {
proposeTitle: "اقتراح مهمة متابعة",
proposeHint: "تنتظر الاعتماد. بعد اعتمادها يمكن تعيينها وتحديد موعدها.",
titleLabel: "العنوان",
descriptionLabel: "الوصف",
dictate: "إملاء",
improving: "جارٍ التحسين…",
improveWithAi: "تحسين باستخدام الذكاء الاصطناعي",
followOnTitleAria: "عنوان مهمة المتابعة",
titlePlaceholder: "العنوان",
followOnDescriptionAria: "وصف مهمة المتابعة",
descriptionPlaceholder: "ما هو العمل الإضافي المطلوب؟",
insertingDictatedText: "جارٍ إدراج نص تم إملاؤه...",
finishingDictation: "جارٍ إنهاء الإملاء...",
heardTranscript: "ما سُمع: {{transcript}}",
listening: "الاستماع...",
photosAndVideos: "الصور ومقاطع الفيديو",
requiredSkills: "المهارات المطلوبة",
cancel: "إلغاء",
submitting: "جارٍ الإرسال…",
submitForApproval: "أرسل للموافقة",
rejectTitle: "رفض مهمة المتابعة",
rejectHint: "تُلغى مهمة المتابعة. أضف سبباً قصيراً للفريق.",
rejectionReasonAria: "سبب الرفض",
reasonPlaceholder: "السبب",
rejectFollowOn: "رفض",
},
dockBar: {
  waitingForRequester: "بانتظار مقدم الطلب",
approve: "الموافقة",
reject: "رفض",
accept: "قبول",
acceptAndStart: "قبول وبدء",
acceptAndSchedule: "قبول وجدولة",
cantDoThis: "رفض",
reassign: "إعادة التكليف",
rework: "إعادة للتعديل",
requestEvidence: "طلب صور",
verify: "اعتماد",
resubmit: "إعادة الإرسال",
getQuotes: "احصل على عروض الأسعار",
inviteMore: "قم بدعوة المزيد",
compare: "مقارنة",
sendQuotes: "إرسال عروض الأسعار",
assign: "تكليف",
startNow: "البدء الآن",
schedule: "الجدولة",
start: "البدء",
reschedule: "إعادة الجدولة",
complete: "إكمال",
pause: "إيقاف مؤقت",
resume: "استئناف",
report: "التقرير",
},
certificateSuggestion: {
needsConnection: "تحتاج اقتراحات الشهادات إلى اتصال.",
evidenceDoesNotSupport: "لا تدعم أدلة الإكمال الشهادة بشكل واضح حتى الآن.",
createPendingTitle: "إنشاء شهادة معلقة",
createPendingBody: "هل تريد إنشاء شهادة من أمر العمل هذا؟ ستبقى بانتظار التحقق حتى تتم مراجعتها.",
cancel: "إلغاء",
continue: "متابعة",
jobFallback: "مهمة",
certificateSuffix: "شهادة {{title}}",
titleLine: "العنوان: {{value}}",
typeLine: "النوع: {{value}}",
expiryLine: "تاريخ الانتهاء: {{value}}",
cardTitle: "اقتراح شهادة من أدلة الإنجاز",
optionalAiHint: "مساعدة اختيارية بالذكاء الاصطناعي بعد إكمال المهمة.",
reviewDraftLabel: "مراجعة مسودة الشهادة",
suggestWithAi: "اقتراح شهادة باستخدام الذكاء الاصطناعي",
addManually: "أضف الشهادة يدويًا",
},
verified: {
  submitCheckNote: "عند الإرسال، يقارن الذكاء الاصطناعي صور «بعد» بما تتطلبه المهمة.",
  documentHintSheet: "أغلق هذا، ثم اضغط إرفاق مستند في المهمة.",
  noteHintSheet: "اكتبها في ملاحظة الإنجاز على هذه الشاشة.",
  noteHint: "اكتبها في ملاحظة الإنجاز عند الضغط على إكمال.",
  attachDocument: "إرفاق مستند",
  recordReading: "تسجيل القراءة",
  heading: "ما يحتاجه هذا العمل",
  progress: "أُنجز {{done}} من {{total}}",
  takePhoto: "التقاط صورة",
  stage: {
    pre: "قبل البدء",
    post: "عند الانتهاء",
    standalone: "قائمة تحقق",
  },
  beforePhoto: "صورة قبل",
  afterPhoto: "صورة بعد",
  beforePhotos: "صور قبل",
  addBeforePhoto: "إضافة صورة قبل",
  required: "مطلوب",
  recommended: "موصى به",
  rowState: {
    notSupplied: "لم يُقدَّم",
    done: "تم",
    uploading: "جارٍ الرفع…",
    added: "أُضيفت",
    missing: "ناقص",
    attention: "يحتاج إلى مراجعة",
    unchecked: "لم يُفحص بعد",
  },
  status: {
    consistent: "الصور تطابق العمل الموصوف",
    review_required: "الصور تحتاج إلى مراجعة",
    missing_evidence: "الصور ناقصة",
    inconsistent: "الصور لا تطابق العمل الموصوف",
    unable_to_determine: "تعذّر التحقق من الصور",
  },
  checkNote: {
    meter_not_recorded: "لم تُسجَّل قراءة العداد",
    document_not_attached: "لم يُرفق المستند",
    check_not_completed: "لم يكتمل الفحص",
    note_missing: "الملاحظة مفقودة",
    not_visible: "غير ظاهر في الصور",
    partly_visible: "ظاهر جزئيًا فقط",
    low_confidence: "غير واضح بما يكفي",
    contradicted: "الصور تُظهر العكس",
    cloud_unavailable: "التقييم الآلي غير متاح",
    not_visually_verifiable: "لا يمكن تحديده من الصور",
  },
  warning: {
    cloud_unavailable: "التقييم الآلي غير متاح. لا يزال بإمكان المراجع فحص الأدلة.",
    subject_mismatch: "قد لا تُظهر صور قبل وبعد المكوّن نفسه.",
    low_quality_after: "صور بعد ضبابية أو مظلمة أو محجوبة. يُوصى بصور أوضح.",
    new_defect_after: "يظهر في صور بعد عيب لم يشمله العمل.",
    detector_disagreement: "نتائج الصور متضاربة. سيقرر شخص من الفريق.",
    pending_uploads: "لا تزال بعض الصور قيد الرفع ولم تُقيَّم.",
    reviewer_required: "يجب أن يوافق مراجع على هذا العمل.",
    post_inspection_required: "الفحص النهائي معلّق.",
  },
  moreEvidenceRequested: "طُلبت صور إضافية",
  stale: "تغيّرت الأدلة. يجب تحديث التقييم.",
  checkEvidence: "فحص الصور",
  checkAgain: "فحص مرة أخرى",
  checking: "جارٍ فحص أدلة الإنجاز…",
  checkEvidenceA11y: "فحص أدلة الإنجاز",
  resubmit: "إعادة الإرسال",
  resubmitA11y: "إعادة إرسال الإنجاز مع الأدلة المضافة",
  resubmitted: "أُعيد إرسالها للمراجعة. تم إبلاغ المراجع.",
  requestEvidence: "طلب صور",
  requestEvidenceA11y: "طلب صور إضافية",
  cloudUnavailable: "الفحص التلقائي للصور غير متاح الآن. اطّلع على الصور وقرّر.",
  reportEyebrow: "تقييم الأدلة (آلي)",
  editRequirements: "تعديل المتطلبات",
  editSummary: "قوائم التحقق والصور والنتائج لهذا العمل",
  saved: "حُفظت المتطلبات. أي تقييم سابق يحتاج إلى تحديث.",
  suggestFailed: "لم تصل اقتراحات. أضف النتائج يدويًا.",
  kind: {
    visual: "يظهر في الصور",
    meter: "قراءة عداد",
    document: "مستند",
    check: "قائمة فحص",
    note: "ملاحظة",
  },
  remove: "إزالة",
  removeA11y: "إزالة «{{text}}»",
  addOutcomePlaceholder: "أضف نتيجة متوقعة، مثل: الواقي البديل موجود",
  addOutcome: "إضافة نتيجة",
  suggestWithAi: "اقتراح بالذكاء الاصطناعي",
  saveRequirements: "حفظ المتطلبات",
  reportPhotosAssessed: "تم تقييم الصور",
  reportRecordsOnly: "السجلات فقط",
},
closeoutPane: {
askForPhotos: "طلب صور",
viewCompletionReport: "عرض تقرير الإكمال",
emailCloseoutRecipients: "أرسل التقرير إلى مقدم الطلب",
sending: "جارٍ الإرسال…",
waitingOnRequester: "بانتظار مقدم الطلب",
verifyCompletedWork: "اعتماد العمل المكتمل",
requesterGatePendingBody: "يراجع مقدم الطلب العمل أولاً. بعد أن يؤكد رضاه، اضغط تحقق لإغلاق المهمة. لا يزال بإمكانك الإعادة للتعديل.",
requesterAcceptedBody: "أكد مقدم الطلب رضاه عن العمل. اضغط اعتماد لإغلاق المهمة.",
reviewAndApproveBody: "راجع الملاحظة والصور والتكاليف، ثم اضغط اعتماد لإغلاق المهمة، أو إعادة للتعديل إذا كان هناك ما يحتاج إصلاحاً.",
requestRework: "إعادة للتعديل",
rework: "إعادة للتعديل",
verify: "اعتماد",
certificateRenewalTitle: "تجديد الشهادة",
certificateRenewalBody: "قم بإنشاء شهادة الاستبدال من أمر العمل المكتمل هذا واربطها بالشهادة السابقة.",
createCertificateFromJob: "إنشاء شهادة من أمر العمل",
createCertificate: "إنشاء الشهادة",
},
assignSheet: {
  chooseContractorsToQuote: "اختر المقاولين لتقديم عروض أسعار",
  chooseContractor: "اختر مقاولاً",
  assignToContractor: "تعيين لمقاول",
  inviteTeammate: "دعوة زميل",
close: "إغلاق",
youSuffix: "{{name}} (أنت)",
searchTeamMembersPlaceholder: "ابحث عن أعضاء الفريق…",
noTeamMemberMatch: "لا يوجد عضو مطابق في الفريق.",
createTeamHint: "أضف زميلاً لتعيين العمل له، أو عيّنه لنفسك.",
teammate: "تعيين لزميل في الفريق",
assignToMyself: "تعيين لنفسي",
},
},
create: {
  skillsTryAgain: "حاول مرة أخرى",
  skillsEmpty: "لا توجد مهارات للاختيار الآن. اضغط حاول مرة أخرى، أو تابع بدونها.",
  createAndAssignJob: "إنشاء المهمة وتعيينها",
  fromRequestPageTitle: "تأكيد المهمة من الطلب",
  checkAttachFailedTitle: "تم إنشاء المهمة، وقائمة التحقق ناقصة",
  assetLoadFailed: "تعذر تحميل الأصل المرتبط. تحقق من اتصالك وأعد المحاولة.",
  assetUnavailable: "هذا الأصل غير متاح أو لم تعد لديك صلاحية الوصول إليه.",
  assetStatus: {
    retired: "خارج الخدمة نهائيًا",
    archived: "مؤرشف",
    active: "نشط",
  },
  visibilityHint: "خاص: أنت والأشخاص في هذه المهمة فقط. الفريق: كل أفراد فريقك.",
  priorityOption: {
    critical: "حرجة",
    high: "عالية",
    medium: "متوسطة",
    low: "منخفضة",
  },
  categoryOption: {
    other: "أخرى",
    replacement: "استبدال",
    inspection: "فحص",
    maintenance: "صيانة",
    repair: "إصلاح",
  },
unsavedGuard: {
message: "لم تُنشأ هذه المهمة بعد. هل تريد المغادرة وفقدانها؟",
discard: "مغادرة",
keep: "استمر في التحرير",
},
assetRetiredTitle: "الأصل خارج الخدمة نهائيًا",
assetArchivedTitle: "تمت أرشفة الأصل",
assetRetiredBody: "تم إخراج هذا الأصل من الخدمة. يظل سجله قابلاً للقراءة، لكنه لا يقبل مهام جديدة.",
assetArchivedBody: "تمت أرشفة هذا الأصل. لا يزال بإمكانك عرض/تحرير الأصل، ولكن لا يمكنك إنشاء أوامر عمل جديدة له.",
linkFollowUpFallback: "لم يتم تحديث الطلب.",
checkAttachFailed: "تم إنشاء المهمة، لكن لم تُضف قائمة التحقق \"{{name}}\". افتح المهمة واضغط إضافة فحص.",
createFailed: "لم تُنشأ المهمة. تم الاحتفاظ بتفاصيلك. تحقق من اتصالك وحاول مرة أخرى.",
error: "حدث خطأ ما",
followUpLinked: "متابعة مرتبطة بأمر العمل",
calendarInviteTitle: "أمر العمل: {{name}}",
genericAssetFallback: "أصل",
recovery: {
followUpTitle: "تم إنشاء المهمة، ولم يُحدَّث الطلب",
followUpBody: "{{message}} تم إنشاء المهمة. اضغط إعادة محاولة الربط ليظهر في الطلب.",
retryLink: "إعادة محاولة الربط",
openJob: "فتح المهمة",
assetErrorTitle: "تعذّر تحميل الأصل المرتبط",
assetLoadingTitle: "جارٍ تحميل الأصل المرتبط...",
assetErrorBody: "{{error}} يتم الاحتفاظ بملخص العمل الذي قمت بإدخاله.",
retryAsset: "إعادة تحميل الأصل",
requestErrorTitle: "تعذر تحميل الطلب",
requestErrorBody: "يجب تعبئة أمر العمل هذا مسبقًا من الطلب. أعد محاولة تحميل تفاصيله — سيتم الاحتفاظ بأي شيء قمت بإدخاله بالفعل.",
retry: "إعادة المحاولة",
},
createdFromRequest: "تم الإنشاء بناءً على الطلب",
createdFromAsset: "تم الإنشاء من الأصل",
notSet: "غير محدد",
noPriority: "بدون أولوية",
openAsset: "فتح الأصل",
followOnDetailsTitle: "تفاصيل مهمة المتابعة",
workBriefTitle: "ملخص العمل",
followOnHint: "مرتبطة بالمهمة الأصلية{{parent}}. تستخدم الأصل نفسه وطريقة التنفيذ نفسها. عيّنها واختر موعداً بعد اعتمادها.",
workPathTitle: "من سينفذها؟",
linkAssetLabel: "الربط بأصل (اختياري)",
selectAssetPlaceholder: "اختر أصلًا",
titleLabel: "العنوان",
titlePlaceholder: "مثال: إصلاح تسرب الصنبور",
titleError: "أدخل عنوان أمر العمل للمتابعة.",
descriptionLabel: "وصف المشكلة (اختياري)",
descriptionPlaceholder: "ما الذي يجب القيام به؟ أضف تفاصيل ليكون لدى المكلَّف سياق كافٍ.",
dictateStop: "إيقاف",
dictateStart: "إملاء",
cleaningUp: "جارٍ التحسين…",
aiCleanUp: "حسّن بالذكاء الاصطناعي",
photosLabel: "الصور (اختياري، بحد أقصى 3)",
completionEvidence: {
  title: "أدلة الإنجاز",
  summary: "ما الأدلة المطلوبة على إتمام هذا العمل",
  beforePhoto: "صورة قبل",
  afterPhoto: "صورة بعد",
  level: {
    none: "غير مطلوب",
    recommended: "موصى به",
    required: "مطلوب",
  },
  reviewerRequired: "يجب أن يوافق مراجع",
  postInspection: "فحص بعد العمل",
  requiredHint: "الأدلة المطلوبة تمنع الإنجاز حتى تُضاف.",
  recommendedHint: "الأدلة الموصى بها تُنبّه فقط ولا تمنع أبدًا.",
},
categoryLabel: "الفئة *",
categoryError: "اختر فئة للمتابعة.",
skillsOptionalLabel: "المهارات (اختياري)",
requiredSkillsLabel: "المهارات المطلوبة",
requiredSkillsError: "اختر مهارة واحدة على الأقل لمهمة المتابعة. تُملأ مهارات المهمة الأصلية إن وُجدت.",
requiredSkillsHint: "اختر مهارة واحدة على الأقل. تُملأ مهارات المهمة الأصلية إن وُجدت.",
addContext: "إضافة سياق (اختياري)",
priorityLabel: "الأولوية",
locationLabel: "الموقع (اختياري)",
locationPlaceholder: "البحث عن عنوان…",
assignScheduleTitle: "تعيين وجدولة",
assignScheduleSummary: "تاريخ الاستحقاق والجدول الزمني والمكلَّف",
dueDateLabel: "تاريخ الاستحقاق (اختياري)",
selectDatePlaceholder: "اختر التاريخ",
dueDateHint: "تاريخ الانتهاء المستهدف. اترك الجدولة فارغة إذا كان هذا العمل لا يحتاج إلى فترة محددة بعد.",
scheduledDateLabel: "التاريخ المجدول (اختياري)",
planDatePlaceholder: "تاريخ الخطة",
startTimeLabel: "وقت البدء",
selectTimePlaceholder: "حدد الوقت",
estimatedDurationLabel: "المدة المقدرة",
suggestedDuration: "المقترح: {{duration}} ({{reason}})",
useSuggestedDuration: "استخدم المدة المقترحة",
applied: "تم التطبيق",
useSuggestion: "استخدم الاقتراح",
plannedPreview: "المخطط له: {{preview}}",
clearSchedule: "مسح الجدول",
inviteLabel: "دعوة (اختياري)",
setDateHint: "حدد تاريخًا لتخطيط موعد بدء العمل.",
quotesContractorHint: "يمكنك اختيار المقاولين الذين تريد دعوتهم لعرض الأسعار بعد إنشاء أمر العمل.",
directContractorHint: "يمكنك اختيار المقاول بعد إنشاء أمر العمل.",
assignTeamMemberLabel: "تعيين لعضو الفريق (اختياري)",
searchTeamMembersPlaceholder: "ابحث عن أعضاء الفريق…",
noTeamMemberMatch: "لا يوجد عضو مطابق في الفريق.",
assignSuggestedMember: "قم بتعيين العضو المقترح، {{name}}",
suggestedAssignee: "المقترح: {{name}}",
assignAnytimeHint: "قم بالتعيين الآن أو التعيين بعد إنشاء أمر العمل.",
advancedSettingsTitle: "تفاصيل إضافية",
advancedSettingsSummary: "الفئة والمدة والفحوصات ودعوة التقويم والتكلفة والظهور",
estimatedCostLabel: "التكلفة المقدرة (اختياري)",
estimatedCostAmount: "مبلغ التكلفة المقدرة",
visibilityLabel: "الظهور",
submitting: "جارٍ الإرسال…",
submitForApproval: "أرسل للموافقة",
creating: "جارٍ الإنشاء…",
createJob: "إنشاء مهمة",
followOnPageTitle: "اقتراح مهمة متابعة",
createPageTitle: "إنشاء مهمة",
followOnSubtitle: "تنتظر الاعتماد قبل أن يمكن تعيينها.",
requestSubtitle: "راجع التفاصيل، واختر من سينفذها وموعدها، ثم اضغط إنشاء المهمة وتعيينها.",
manualSubtitle: "قم بوصف العمل واختيار الفئة. يمكنك تعيينه وجدولته بعد ذلك.",
linkAssetSheetTitle: "الربط بأصل",
noneOption: "بلا",
openLinkedAsset: "فتح الأصل المرتبط",
cleanedDescriptionTitle: "الوصف بعد التحسين",
cleaningUpDescription: "جارٍ تحسين الوصف",
reviewSuggestedWording: "راجع الصياغة المقترحة قبل تطبيقها.",
unableToCleanUpTitle: "غير قادر على تنظيف الوصف",
tryAgain: "حاول مرة أخرى.",
},
recurring: {
  addStepNote: "تصبح هذه الخطة الخطوة {{n}} في {{name}}.",
  saved: {
    dateInspection: "حُفظت الخطة. يظهر الفحص الأول في العمل في {{when}}.",
    dateJob: "حُفظت الخطة. تظهر المهمة الأولى في العمل في {{when}}.",
    meterInspection: "حُفظت الخطة. يظهر الفحص الأول في العمل عندما يصل العداد إلى {{amount}}.",
    meterJob: "حُفظت الخطة. تظهر المهمة الأولى في العمل عندما يصل العداد إلى {{amount}}.",
    eitherInspection: "حُفظت الخطة. يظهر الفحص الأول في العمل عند {{amount}} أو في {{when}}، أيهما أقرب.",
    eitherJob: "حُفظت الخطة. تظهر المهمة الأولى في العمل عند {{amount}} أو في {{when}}، أيهما أقرب.",
    conditionInspection: "حُفظت الخطة. يظهر فحص في العمل عندما تنخفض درجة الحالة إلى {{score}} أو أقل.",
    conditionJob: "حُفظت الخطة. تظهر مهمة في العمل عندما تنخفض درجة الحالة إلى {{score}} أو أقل.",
    manual: "حُفظت الخطة. لن يظهر شيء في العمل حتى يضغط أحدهم «ابدأ الآن» في تبويب الصيانة الخاص بالأصل.",
    needsReading: "حُفظت الخطة. سجّل قراءة عداد على الأصل لتبدأ في العد.",
    nowInspection: "حُفظت الخطة. الفحص الأول موجود الآن في العمل.",
    nowJob: "حُفظت الخطة. المهمة الأولى موجودة الآن في العمل.",
    generic: "حُفظت الخطة. ستجدها في تبويب الصيانة الخاص بالأصل.",
  },
  skipPolicy: {
    hint: {
      not_allowed: "يمكن نقل الزيارة أو تسليمها لشخص آخر، لكن لا يمكن تخطيها أبدًا.",
      no_approval: "يمكن لمن ينفذ العمل تخطي الزيارة فورًا، ويُبلَّغ معتمدو الأصل.",
      team_admin: "لا يوافق على تخطي زيارة إلا مالك الفريق أو مسؤوله.",
      requires_approval: "يمكن لأي شخص طلب تخطي زيارة أو نقلها، ويقرر أحد معتمدي الأصل.",
      default: "إن لم تختر: يقرر المدير، أو مسؤول الفريق إذا كان على الأصل التزام امتثال.",
    },
    not_allowed: "عدم التخطي أبدًا",
    no_approval: "التخطي دون طلب إذن",
    team_admin: "يقرر مسؤول الفريق",
    requires_approval: "يقرر المدير",
    label: "إذا تعذّر إنجاز زيارة",
  },
  meterNowHint: "تُحفظ كأول قراءة حتى تعرف الخطة من أين تبدأ العد.",
  meterNow: "قراءة العداد الآن",
  createTemplate: "إنشاء قائمة تحقق",
  noTemplates: "لا توجد قوائم تحقق فحص بعد. أنشئ قائمة تحققًا وسيُختار هنا تلقائيًا.",
  addDocument: "إضافة مستند",
  pickAssetFirst: "اختر الأصل أولًا، ثم اختر أحد مستنداته.",
  cannotManage: "لا يمكنك إضافة خطط إلى {{asset}}. اطلب ذلك من مالكه أو من مسؤول الفريق.",
  assetPickerSubtitle: "تخص الخطة أصلًا واحدًا. يظهر عملها في العمل مرتبطًا بذلك الأصل.",
maintenanceSave: "إنشاء الخطة",
maintenanceSuccessTitle: "تم إنشاء الخطة",
maintenanceSuccessBody: "يُنشأ العمل عند استحقاق الخطة. أدرها من تبويب الصيانة للأصل.",
maintenanceHeading: "خطة صيانة",
maintenanceSub: "عمل يتكرر — صيانة أو اختبار أو فحص. اختر الأصل، واذكر ما يجب إنجازه ومتى يحين موعده. تظهر المهمة في العمل في كل مرة يحين فيها موعدها.",
modeWhenDue: "عند الاستحقاق",
repeatEvery: "التكرار حسب التاريخ",
everyCount: "كل",
unit: {
hours: "ساعات",
days: "أيام",
weeks: "أسابيع",
months: "أشهر",
years: "سنوات",
},
edit: {
  loadFailed: "تعذّر فتح هذه الخطة. تحقق من اتصالك وحاول مرة أخرى.",
heading: "تعديل الخطة",
sub: "تُطبَّق التغييرات من الدورة التالية للخطة. العمل الذي أُنشئ مسبقًا يبقى دون تغيير.",
save: "حفظ التغييرات",
savedTitle: "تم تحديث الخطة",
savedBody: "يُطبَّق التغيير من الدورة التالية للخطة. العمل الذي أُنشئ مسبقًا يبقى دون تغيير.",
notFound: "تعذّر العثور على هذه الخطة. قد تكون قد انتهت.",
conflict: "حفظ شخص آخر هذه الخطة بعد أن فتحتها. لم تُطبَّق تغييراتك — ارجع وافتحها مجددًا وأعد إجراءها.",
},
meterEvery: "التكرار حسب العدّاد",
meterInterval: "كل",
meterKind: {
mileage: "المسافة المقطوعة",
operating_hours: "ساعات التشغيل",
cycles: "الدورات",
},
meterCurrent: "يقرأ العدّاد {{amount}} الآن.",
meterNoReading: "لا توجد قراءة حتى الآن — سجّل واحدة على الأصل حتى يكون للخطة أساس تحسب منه.",
whicheverFirst: "أيهما يأتي أولًا",
lastDone: "آخر تنفيذ (اختياري)",
lastDoneDate: "التاريخ",
lastDoneTime: "الوقت",
lastDoneMeter: "قراءة العدّاد في آخر خدمة",
lastDoneHint: "اتركه فارغًا للحساب من اليوم والقراءة الحالية.",
moreOptions: "خيارات أخرى",
meterAlso: "كرّر أيضًا حسب قراءة العدّاد",
meterRemove: "إزالة التكرار حسب العدّاد",
unitPickerTitle: "يتكرر كل",
lastDoneHintNow: "اتركه فارغًا إن لم يُنجَز من قبل.",
whoDoesIt: "من ينفّذه (اختياري)",
nobodyYet: "أقرّر في كل مرة",
whoDoesItHint: "تُسند كل زيارة إلى {{name}}، ويُبلَّغ عند وصولها.",
nobodyYetHint: "تصل كل زيارة قبل موعدها بما يصل إلى أسبوعين، ويُطلب منك إسنادها، مع تذكير قبل 3 أيام.",
assetPlaceholder: "اختيار أصل",
firstRunDatePlaceholder: "التاريخ",
firstRunTimePlaceholder: "الوقت",
ok: "حسنًا",
unsavedGuard: {
editMessage: "لم تُحفظ التغييرات التي أجريتها على هذه الخطة. هل تريد المغادرة وفقدانها؟",
createMessage: "لم تُحفظ هذه الخطة بعد. هل تريد المغادرة وفقدانها؟",
discard: "مغادرة",
keep: "استمر في التحرير",
},
doItAs: "نفّذها كـ",
asJob: "أمر عمل",
asInspection: "تفتيش",
pickTemplate: "اختر قائمة تحققًا",
serviceReading: "قراءة العدّاد عند الخدمة",
useReading: "استخدم {{amount}} كقراءة الخدمة",
heading: "خطة صيانة",
sub: "تنشئ أمر العمل التالي لك وفق جدول: بعد انتهاء السابق، أو في موعده في التقويم.",
asset: "الأصل",
title: "ما الذي يُنجز",
titlePh: "مثال: الصيانة السنوية",
description: "التفاصيل (اختياري)",
descriptionPh: "ما يجب فعله في كل مرة",
category: "الفئة",
firstRun: "الموعد الأول (التاريخ والوقت)",
recurrence: "التكرار",
advanceMode: "كيف يجب إنشاء أمر العمل التالي؟",
modeCompletion: "بعد انتهاء أمر العمل السابق",
modeCalendar: "في تاريخ الاستحقاق بالتقويم",
modeHint: {
when_due: "يظهر أمر العمل التالي عندما يشير التاريخ أو العدّاد إلى ذلك — أيهما يأتي أولًا. لا يُنشأ شيء قبل ذلك.",
on_completion: "يظهر أمر العمل التالي بعد إكمال أو إلغاء أمر العمل الحالي في هذه السلسلة.",
on_calendar: "يُنشأ أمر عمل جديد عند حلول كل تاريخ استحقاق، حتى إذا كان أمر العمل السابق لا يزال مفتوحًا (إلا إذا فعّلت التخطي أدناه).",
},
skipIfPriorOpen: "تخطَّ المرة التالية إذا كانت السابقة لا تزال مفتوحة",
seriesLimits: "إيقاف التكرار (اختياري)",
seriesLimitsHint: "اترك الحقلين فارغين ليستمر التكرار.",
endDate: "الانتهاء بتاريخ",
endTime: "وقت الانتهاء",
checksHint: "تُضاف إلى كل مهمة تنشئها هذه الخطة.",
maxJobs: "التوقف بعد هذا العدد من المهام",
maxPh: "لا يوجد حد",
save: "إنشاء السلسلة",
saving: "جارٍ الإنشاء…",
successTitle: "تم إنشاء السلسلة",
successBody: "أمر العمل الأول موجود في العمل؛ وستتبع البقية جدولك.",
errorTitle: "لم تُحفظ الخطة",
footer: "الأصل: {{asset}}",
errors: {
  meterNowFailed: "تعذّر حفظ هذه القراءة. تحقق من الرقم وحاول مرة أخرى.",
  meterNow: "أدخل قراءة العداد الحالية.",
every: "أدخل فترة التكرار كرقم صحيح.",
meter: "أدخل فترة التكرار بوحدة {{unit}}.",
noLeg: "أضف تكرارًا حسب التاريخ أو العدّاد أو كلاهما.",
template: "اختر قائمة تحققًا للفحص.",
lastDone: "اختر تاريخ تنفيذ أخير صالح، أو اتركه فارغًا.",
lastDoneMeter: "أدخل القراءة في آخر خدمة، أو اتركها فارغة.",
readingLower: "قراءة الخدمة أقل من القراءة الحالية {{amount}}.",
asset: "اختر الأصل الذي تخصه هذه الخطة.",
title: "اذكر ما الذي يُنجز.",
datetime: "اختر تاريخًا ووقتًا صالحين للموعد الأول.",
endInvalid: "اختر تاريخ توقف صالحًا.",
endBeforeStart: "يجب أن يكون تاريخ التوقف في تاريخ الموعد الأول أو بعده.",
max: "أدخل عدد المهام أو اتركه فارغًا.",
generic: "لم تُحفظ خطتك. تحقق من اتصالك وحاول مرة أخرى.",
},
serviceReadingHint: "تُحتسب الصيانة التالية ابتداءً من هذه القراءة.",
dueBy: "متى يحين موعده؟",
trigger: {
  schedule: "كل…",
  fixed_date: "في تواريخ محددة",
  document_renewal: "عند انتهاء صلاحية مستند",
  condition: "عند تراجع الحالة",
  manual: "بدون جدول، أبدأه بنفسي",
},
triggerHint: {
  fixed_date: "يُنشأ العمل في كل تاريخ.",
  document_renewal: "يُنشأ العمل عند انتهاء صلاحية المستند. يؤدي حفظ تجديده إلى نقل الخطة إلى تاريخ الانتهاء الجديد.",
  condition: "يُنشأ العمل عندما تنخفض درجة حالة الأصل إلى هذه القيمة أو أقل.",
  manual: "لا يُنشأ شيء تلقائيًا. ابدأها من تبويب الصيانة للأصل عند الحاجة.",
},
dates: "التواريخ",
addDate: "إضافة تاريخ",
removeDate: "إزالة هذا التاريخ",
pickDocument: "اختر مستندًا",
documentExpires: "{{title}} · ينتهي في {{when}}",
noDocuments: "لا يوجد لهذا الأصل مستند بتاريخ انتهاء بعد. أضف مستندًا، ثم عد واختره.",
conditionScore: "درجة الحالة (0–100)",
errorDates: "أضف تاريخًا واحدًا على الأقل.",
errorDocument: "اختر المستند الذي يجعل انتهاء صلاحيته الخطة مستحقة.",
errorCondition: "أدخل درجة حالة من 0 إلى 100.",
},
handoff: {
  couldNotLoadTeam: "تعذر تحميل الفريق. تحقق من اتصالك واضغط إعادة المحاولة.",
  assignToMyself: "تعيينها لنفسي",
  inviteTeammate: "دعوة زميل",
  createdSubtitleAssigned: "أصبحت الآن في العمل ومعيّنة إلى {{name}}. اختر موعداً بعد أن يقبلها.",
  createdSubtitle: "أصبحت الآن في العمل. اختر من سينفذها ومتى. سيتم إبلاغه عند تعيينها له.",
  createdTitle: "تم إنشاء المهمة",
  assignTitle_many: "تعيين المهام",
  assignTitle_few: "تعيين المهام",
  assignTitle_two: "تعيين المهام",
  assignTitle_zero: "تعيين المهام",
  assignTitle_other: "تعيين المهام",
  assignTitle_one: "تعيين المهمة",
pageTitle: "تعيين المهمة",
releaseFollowUpTitle: "اعتماد مهمة المتابعة",
releaseSubtitle: "اعتمدها، واختر من سينفذها، وحدد موعداً.",
batchSubtitle: "اختر من سينفذ كل مهمة ومتى. سيتم إبلاغهم عند تعيينها لهم.",
emptyTitle: "لا توجد مهام لتعيينها",
emptyBody: "لا توجد مهام هنا لتعيينها. ارجع إلى العمل للعثور على مهام جديدة.",
backToWork: "العودة إلى العمل",
releaseHandoffTitle: "الاعتماد والتعيين",
smoothHandoffTitle: "عيّن كل مهمة",
releaseIntroText: "تعرض كل بطاقة من طلب العمل ومن سينفذه ومتى ومن سيستلم التقرير النهائي. الاعتماد يتيح تعيينها وتحديد موعدها.",
batchIntroText: "تعرض كل بطاقة من طلب العمل ومن سينفذه ومتى ومن سيستلم التقرير النهائي. بعد تعيين واحدة تظهر التالية.",
applyToAllJobs: "تطبيق على كل المهام ({{count}})",
scheduleAllJobsTogether: "جدولة كافة أوامر العمل معًا",
scheduleTogether: "الجدولة معًا",
setWorkPathToAllJobs: "ضبط كل المهام على: {{mode}}",
allInternal: "الكل لفريقنا",
allToContractor: "الكل لمقاول",
allToQuotes: "طلب عروض أسعار للكل",
pendingRelease: "بانتظار الاعتماد",
requester: "مُقدّم الطلب",
noRequesterLinked: "لم يُربط أي مقدم طلب بعد",
requesterNoneLinked: "لا يوجد مقدم طلب مرتبط، لذا يستلم فريقك التقرير فقط.",
assigneeLine: "المكلَّف: {{name}}",
setOnRelease: "يُحدد عند الاعتماد",
verbAssignToTeam: "تعيين للفريق",
verbAssignToContractor: "تعيين للمقاول",
verbRequestQuotes: "طلب عروض أسعار",
approveAndVerb: "اعتماد و{{verb}}",
changeAssignee: "تغيير المكلف",
workPathLabel: "من سينفذها؟",
assigneeLabel: "المكلَّف",
plannedDateLabel: "التاريخ المخطط له",
completionRecipientsLabel: "من يستلم التقرير النهائي",
requiredSkillsLabel: "المهارات المطلوبة",
notScheduledYet: "لم يُجدول بعد",
awaitingAcceptance: "{{name}} · في انتظار القبول",
notAssignedYet: "لم يُسند بعد",
assignToName: "تعيين إلى {{name}}",
someoneElse: "شخص آخر",
sourceContractorHint: "نفّذ {{name}} المهمة التي نشأت منها هذه.",
awaitingNote: "يمكنك اختيار موعد بعد قبولها",
changeDate: "تغيير التاريخ",
planDate: "اختر تاريخاً",
viewJobLabel: "عرض أمر العمل {{title}}",
viewJob: "عرض المهمة",
doneBackToRequest: "تم · العودة إلى الطلب",
doneBackToAsset: "تم · العودة إلى الأصل",
doneBackToJobs: "تم · العودة إلى أوامر العمل",
doneOpenJob: "تم · فتح أمر العمل",
assignToTeamMemberTitle: "تعيين لعضو الفريق",
teamHintNoTeamAsset: "هذا الأصل غير مرتبط بفريق — سيُستخدم التعيين الشخصي. يمكنك تعيين المهمة لنفسك.",
teamHintNoTeamJob: "لم يُحدَّد فريق لهذه المهمة — تعيين شخصي. يمكنك تعيين المهمة لنفسك.",
teamHintUsingTeam: "استخدام الفريق الذي يدير أمر العمل أو الأصل هذا: {{name}}",
teamHintUsingWorkspaceTeam: "استخدام فريق مساحة العمل المرتبط بأمر العمل أو الأصل هذا.",
loadingTeamMembers: "جارٍ تحميل أعضاء الفريق...",
retry: "إعادة المحاولة",
noTeamMembersTitle: "لا يوجد أحد آخر في الفريق بعد",
noTeamMembersBody: "أضف زميلاً لتعيين العمل له، أو عيّنه لنفسك.",
refresh: "تحديث",
unnamedMember: "عضو لم يذكر اسمه",
youSuffix: " (أنت)",
scheduleJobsTogetherTitle: "جدولة أوامر العمل {{count}} معًا",
planHandoffDateTitle: "متى سيتم تنفيذها؟",
scheduleTogetherText: "سيتم تطبيق نفس التاريخ والوقت والمدة المقدرة على كل أمر عمل مؤهل في هذه الدفعة.",
planHandoffDateText: "اختر اليوم والوقت الذي يجب أن يتم فيه العمل.",
dateLabel: "التاريخ",
timeLabel: "الوقت",
estimatedDurationLabel: "المدة المقدرة",
cancel: "إلغاء",
saveForJobs: "حفظ لأوامر العمل {{count}}",
saveDate: "حفظ التاريخ",
chooseContractorsForQuotes: "اختر المقاولين لعروض الأسعار",
assignToContractorTitle: "تعيين للمقاول",
addContractor: "إضافة مقاول",
error: "حدث خطأ ما",
failedApplyWorkPathAll: "لم تتغير كل المهام. تحقق من اتصالك وحاول مرة أخرى.",
failedUpdateWorkPath: "لم يُحفظ من سينفذها. تحقق من اتصالك وحاول مرة أخرى.",
failedAssign: "لم تُعيَّن المهمة. تحقق من اتصالك وحاول مرة أخرى.",
failedReleaseFollowUp: "لم تُعتمد مهمة المتابعة. تحقق من اتصالك وحاول مرة أخرى.",
failedScheduleJobsTogether: "لم تُحفظ التواريخ. تحقق من اتصالك وحاول مرة أخرى.",
failedSchedule: "لم يُحفظ التاريخ. تحقق من اتصالك وحاول مرة أخرى.",
noTeamTitle: "لا يوجد فريق لهذه المهمة",
noTeamBody: "تعذر معرفة الفريق الذي تتبع له هذه المهمة، لذلك لم تتم دعوة المقاول. تحقق من اتصالك وحاول مرة أخرى.",
assignedTitle: "تم التعيين، لكن لم يُرسل البريد",
assignedInviteFailedBody: "أصبحت المهمة له، لكن تعذر إرسال بريد الدعوة. أبلغه بنفسك.",
plannedDateRequiredTitle: "التاريخ المخطط مطلوب",
plannedDateRequiredBody: "اختر تاريخًا مخططًا قبل الحفظ.",
nothingToScheduleTitle: "لا يوجد ما يُجدوَل",
nothingToScheduleBody: "لا توجد أوامر عمل في هذه الدفعة جاهزة للجدولة بعد.",
mustBeAcceptedError: "يجب قبول المهمة قبل اختيار موعد.",
},
updates: {
  audienceEveryone: "كل من في هذه المهمة",
  audienceTeam: "فريقي فقط",
  failedToPostUpdate: "لم يُنشر التحديث. تحقق من اتصالك وحاول مرة أخرى.",
  failedToSend: "لم يُرسل تحديثك. تحقق من اتصالك وحاول مرة أخرى.",
  quickPosted: "تم نشر التحديث. يظهر في نشاط المهمة.",
  quick: {
    follow_up_required: {
      note: "هناك حاجة إلى مهمة متابعة.",
      label: "تحتاج مهمة متابعة",
    },
    completed_successfully: {
      note: "تم إنجاز العمل.",
      label: "تم العمل",
    },
    additional_issue_found: {
      note: "وُجدت مشكلة أخرى أثناء العمل.",
      label: "وُجدت مشكلة أخرى",
    },
    awaiting_access: {
      note: "لا يمكن المتابعة: بانتظار الدخول إلى الموقع.",
      label: "بانتظار الدخول",
    },
    awaiting_parts: {
      note: "بانتظار القطع لمتابعة العمل.",
      label: "بانتظار القطع",
    },
    work_in_progress: {
      note: "العمل جارٍ.",
      label: "العمل جارٍ",
    },
    arrived_on_site: {
      note: "وصلت إلى الموقع.",
      label: "وصلت إلى الموقع",
    },
  },
pageTitle: "التحديثات",
jobFallback: "مهمة",
suggestedUpdateTitle: "التحديث المقترح",
accept: "قبول",
expandedUpdate: "تحديث مُوسَّع",
improvedUpdate: "تحديث محسّن",
unableToExpandNote: "غير قادر على توسيع الملاحظة",
unableToImproveNote: "غير قادر على تحسين الملاحظة",
reviewGeneratedWording: "قم بمراجعة الصياغة التي تم إنشاؤها قبل تطبيقها على التحديث.",
photoAccessRequiredTitle: "يلزم الوصول إلى الصور",
photoAccessRequiredBody: "اسمح بالوصول إلى مكتبة الصور لإرفاق صورة.",
photoNotSavedTitle: "لم تُحفظ الصورة",
photoNotSavedFallback: "تعذر حفظ هذه الصورة على الجهاز.",
activityLoadErrorTitle: "تعذر تحميل النشاط. حاول مرة أخرى.",
tryAgain: "إعادة المحاولة",
loadingActivity: "جارٍ تحميل النشاط",
emptyActivity: "لا يوجد نشاط بعد. ستظهر هنا التحديثات والتعليقات والتعيينات وتغييرات الحالة.",
internalBadge: "داخلي",
savedOnThisDevice: "تم الحفظ على هذا الجهاز",
showingRecentUpdates: "عرض آخر 100 تحديث محفوظ.",
showingSavedActivity: "إظهار النشاط المحفوظ.",
lastRefreshed: "آخر تحديث {{date}}. قد تحتاج الصور إلى اتصال.",
refreshActivity: "تحديث النشاط",
refreshing: "جارٍ التحديث…",
quickUpdates: "تحديثات سريعة",
attachPhoto: "أرفق صورة",
startUpdatePlaceholder: "اكتب تحديثًا...",
jobUpdateLabel: "تحديث المهمة",
internalToggleOn: "يرى فريقك فقط هذه الملاحظة، لا المقاول. اضغط لإظهارها لكل من في المهمة.",
internalToggleOff: "يرى كل من في المهمة هذه الملاحظة. اضغط لقصرها على فريقك.",
sendUpdate: "إرسال التحديث",
improving: "جارٍ التحسين...",
improveNote: "تحسين الملاحظة",
expanding: "جارٍ إضافة التفاصيل…",
expandNote: "أضف تفاصيل بالذكاء الاصطناعي",
aiCleanup: "تحسين بالذكاء الاصطناعي",
connectOnceHint: "قم بالاتصال مرة واحدة لفتح مساحة العمل هذه قبل حفظ التحديثات.",
openingWorkspace: "جارٍ فتح مساحة عملك…",
updatesSavedOnDevice_one: "تم حفظ {{count}} تحديث على هذا الجهاز.",
updatesSavedOnDevice_other: "تم حفظ {{count}} تحديث على هذا الجهاز.",
photosSavedOnDevice_one: "تم حفظ {{count}} صورة على هذا الجهاز.",
photosSavedOnDevice_other: "تم حفظ {{count}} صورة على هذا الجهاز.",
syncNeedsAttention: "تحتاج المزامنة إلى انتباهك.",
waitingToSynchronize: "في انتظار المزامنة.",
reviewSynchronization: "مراجعة المزامنة",
syncFailed: "لم يُرسل. تحقق من اتصالك وحاول مرة أخرى.",
couldNotSyncActivity: "تعذر مزامنة نشاط أمر العمل.",
jobPhoto: "صورة أمر العمل",
updatesSavedOnDevice_zero: "لا توجد تحديثات محفوظة على هذا الجهاز.",
updatesSavedOnDevice_two: "تم حفظ تحديثين على هذا الجهاز.",
updatesSavedOnDevice_few: "تم حفظ {{count}} تحديثات على هذا الجهاز.",
updatesSavedOnDevice_many: "تم حفظ {{count}} تحديثًا على هذا الجهاز.",
photosSavedOnDevice_zero: "لا توجد صور محفوظة على هذا الجهاز.",
photosSavedOnDevice_two: "تم حفظ صورتين على هذا الجهاز.",
photosSavedOnDevice_few: "تم حفظ {{count}} صور على هذا الجهاز.",
photosSavedOnDevice_many: "تم حفظ {{count}} صورة على هذا الجهاز.",
},
checkRunner: {
jobStarted: "بدأت المهمة. اضغط إكمال عند الانتهاء من العمل.",
couldNotStartTitle: "تعذر بدء أمر العمل",
tryAgain: "حاول مرة أخرى.",
checkFallbackTitle: "فحص",
stepWord_one: "خطوة",
stepWord_other: "خطوة",
jobStartsWhenDone: "يبدأ أمر العمل عند الانتهاء",
finishPrecheckAndStart: "قم بإنهاء الفحص المسبق وبدء أمر العمل",
doneBackToJob: "تم — العودة إلى أمر العمل",
stepWord_zero: "خطوات",
stepWord_two: "خطوتان",
stepWord_few: "خطوات",
stepWord_many: "خطوة",
},
quotes: {
inclTax: "شامل الضريبة",
declinedLine: "اعتذر {{name}}: {{reason}}",
pageTitle: "مقارنة الأسعار",
inviteOnly: "بالدعوة فقط",
contractorFallback: "متعهد",
durationNotProvided: "المدة غير متوفرة",
priceDeltaVsLowest: "+{{amount}} مقابل الأدنى",
durationDeltaVsFastest: "+{{duration}} مقابل الأسرع",
compareQuotesAction: "مقارنة الأسعار",
recommendOne: "التوصية بعرض",
jobTitleFallback: "طلب عرض سعر",
jobNotFound: "لم يُعثر على أمر العمل.",
awardQuoteConfirmTitle: "منح العقد لـ {{name}}؟",
priceDurationLine: "{{price}} | {{duration}}",
aiRecommendationFavors: "ترجّح توصية الذكاء الاصطناعي حاليًا عرض السعر هذا.",
awardConsequence: "تذهب المهمة إلى {{name}} فورًا. تُرفض كل العروض الأخرى ويُبلَّغ هؤلاء المقاولون.",
awarded: "تم قبول عرض السعر. أصبحت المهمة الآن لـ {{name}}، وأُبلغ المقاولون الآخرون الذين قدّموا عروضًا.",
acceptFailedTitle: "تعذّر قبول عرض السعر",
acceptFailedBody: "لم يُقبل عرض السعر. حدّث هذه الصفحة لترى إن كان قد حُسم مسبقًا، ثم حاول مرة أخرى.",
rejectFailedTitle: "تعذّر رفض عرض السعر",
rejectFailedBody: "لم يُرفض عرض السعر. حدّث هذه الصفحة، ثم حاول مرة أخرى.",
acceptQuoteFallbackMessage: "هل تريد قبول عرض السعر هذا وتحديث أمر العمل بالمقاول والتكلفة المتوقعة والمدة المتوقعة؟",
awardQuoteTitle: "اختيار عرض السعر",
cancel: "إلغاء",
award: "منح العقد",
error: "خطأ",
failedAcceptQuote: "فشل في قبول عرض الأسعار",
rejectQuoteConfirmTitle: "هل ترفض عرض أسعار {{name}}؟",
decisionTrackedNotify: "يتم تتبع هذا القرار ويمكن إخطار المقاول به.",
rejectQuoteFallbackMessage: "هل تريد رفض عرض السعر هذا؟ يمكن إبلاغ المقاول، ويُسجَّل هذا القرار.",
rejectQuoteTitle: "رفض عرض السعر",
reject: "رفض",
failedRejectQuote: "تعذّر رفض عرض السعر",
aiQuoteIntelligenceTitle: "تحليل عروض الأسعار بالذكاء الاصطناعي",
aiGroundedHint: "يعتمد فقط على حقول عروض الأسعار المقدَّمة. راجعها قبل اتخاذ القرار النهائي.",
generatingAiInsights: "جارٍ إنشاء رؤى الذكاء الاصطناعي...",
refreshAiInsights: "تحديث رؤى الذكاء الاصطناعي",
generateAiInsights: "إنشاء رؤى الذكاء الاصطناعي",
lastUpdated: "آخر تحديث: {{date}}",
comparisonInsightsLabel: "رؤى المقارنة",
notableDifferencesLabel: "اختلافات ملحوظة",
bestValueSuggestionLabel: "اقتراح أفضل قيمة (مساعد)",
suggestedQuote: "عرض السعر المقترح: {{name}}",
noSingleQuoteSuggested: "لم يُقترح عرض سعر واحد بعد (الأدلة غير كافية).",
cautionLine: "تحذير: {{caution}}",
confidenceLine: "الثقة: {{confidence}}",
unableToGenerateAiInsights: "تعذر إنشاء رؤى الذكاء الاصطناعي.",
comparisonSummaryLabel: "مقارنة العروض",
priceRangeLine: "النطاق السعري: {{low}} إلى {{high}}",
priceDataUnavailable: "بيانات السعر غير متاحة.",
durationRangeLine: "نطاق المدة: {{fast}} إلى {{slow}}",
durationDataUnavailable: "بيانات المدة غير متاحة.",
jobContextLabel: "سياق أمر العمل",
assetLine: "الأصل: {{name}}",
noLinkedAsset: "لا توجد أصول مرتبطة",
locationLine: "الموقع: {{value}}",
categoryLine: "الفئة: {{value}}",
urgencyLine: "الاستعجال: {{value}}",
requestProgressLabel: "تقدم الطلب",
inviteSummaryLine: "{{invited}} مدعو · تم إرسال {{submitted}} · رفض {{declined}}",
inviteSummaryPendingSuffix: " · {{pending}} بانتظار الرد",
responseDeadlineLine: "الموعد النهائي للرد: {{date}}",
targetWindowLine: "الفترة المستهدفة: من {{start}} إلى {{end}}",
budgetLine: "الميزانية: {{value}}",
scopeLabel: "النطاق",
noOpenQuotesTitle: "لا توجد عروض أسعار مفتوحة لاتخاذ القرار",
noOpenQuotesBody: "يمكن للمقاولين المدعوين تقديم عروض الأسعار. تظهر القرارات هنا.",
allDeclinedBody: "رفض كل من طلبت منهم. ادعُ مزيدًا من المقاولين للحصول على سعر.",
headerContractor: "متعهد",
headerPrice: "السعر",
headerDuration: "المدة",
headerAvailability: "التوفر",
headerScopeExclusions: "النطاق / الاستثناءات",
headerAiSummary: "ملخص بالذكاء الاصطناعي",
scopeResponseMissing: "الرد على نطاق العمل مفقود",
missingLine: "مفقود: {{items}}",
completeResponse: "الاستجابة الكاملة",
bestPriceChip: "أفضل الأسعار",
fastestChip: "الأسرع",
aiRecommendedChip: "يوصي به الذكاء الاصطناعي",
runAiInsightsToGenerateSummary: "قم بتشغيل رؤى الذكاء الاصطناعي لإنشاء ملخص.",
acceptedQuoteLabel: "عرض أسعار مقبول",
rejectedQuotesLabel: "عروض الأسعار المرفوضة",
reasonLine: "السبب: {{reason}}",
selectQuoteTitle: "حدد عرض أسعار",
selectQuoteBody: "اختر صف عرض سعر لفحص التفاصيل ورؤى الذكاء الاصطناعي وقرارات المنح.",
rejecting: "جارٍ الرفض...",
awarding: "جارٍ منح العقد...",
awardQuoteAction: "اختيار عرض السعر",
openJob: "فتح المهمة",
bestPriceAndFastest: "أفضل الأسعار والأسرع",
fastestDuration: "أسرع مدة",
submittedQuoteStatus: "عرض أسعار مرسل",
applyingDecision: "جارٍ تطبيق القرار…",
aiIntelligenceLabel: "تحليل الذكاء الاصطناعي",
includedLabel: "مُدرج",
excludedLabel: "مستبعد",
caveatsLabel: "ملاحظات",
aiSummaryIncludedLine: "المتضمن: {{items}}",
aiSummaryExcludedLine: "المستبعد: {{items}}",
aiSummaryCaveatsLine: "ملاحظات: {{items}}",
recommendationLabel: "توصية",
recommendationValue: "{{name}} ({{confidence}})",
noneFallback: "بلا",
whatsIncludedHeading: "ما هو مدرج",
notProvidedFallback: "غير متوفر",
materialsLabel: "المواد",
notIncludedFallback: "غير متضمن",
warrantyLabel: "ضمان",
availabilityRangeArrow: "{{start}} ← {{end}}",
exclusionsLabel: "الاستثناءات",
evidenceLabel: "الدليل",
missingInfoLine: "المعلومات المفقودة: {{items}}",
linkedContextHeading: "السياق المرتبط",
jobLabelKv: "مهمة",
assetLabelKv: "أصل",
noScopeProvided: "لم يتم توفير النطاق",
requestNotesLabel: "ملاحظات الطلب",
noNotesProvided: "لم يتم تقديم أي ملاحظات",
inviteMoreContractors: "دعوة مزيد من المقاولين",
scopeResponseLine: "ما يشمله السعر: {{value}}",
durationLine: "المدة: {{value}}",
availabilityToLine: "التوفر: من {{start}} إلى {{end}}",
exclusionsLine: "يشمل: {{value}}",
evidenceLine: "الدليل: {{value}}",
warrantyLine: "الضمان: {{value}}",
attachmentsLine: "المرفقات: {{count}}",
aiSummaryLabel: "ملخص بالذكاء الاصطناعي",
fastestDurationChip: "أسرع مدة",
acceptQuote: "قبول عرض السعر",
},
share: {
  relationshipChangeA11y: "تغيير صلته بالأصل",
  relationshipChange: "تغيير",
  relationship: "صلته: {{role}}",
  openJob: "فتح المهمة",
  editContactDetails: "تعديل بيانات الاتصال",
  copyLink: "نسخ الرابط",
  emailNotSent: "تمت المشاركة، لكن لم يُرسل البريد. انسخ الرابط لإرساله بنفسك.",
  checkDetails: "راجع جهة الاتصال والدور والبريد، ثم اضغط إرسال مجدداً.",
  emailRequired: "أدخل بريده الإلكتروني. سيُرسل رابط التقرير إليه.",
  roleRequired: "اختر صفته، مثل مقدم الطلب.",
  addEmail: "أضف البريد الإلكتروني",
  chooseRole: "اختر الدور",
  chooseContact: "اختر جهة اتصال",
jobFallback: "مهمة",
couldNotLoadReport: "تعذر تحميل هذا التقرير. حاول ثانية.",
greetingDefault: "مرحبًا،\n\nإليك تقرير إكمال المهمة لـ {{name}}. تم الانتهاء من العمل وتوثيقه لسجلاتك.\n\nشكرًا لك.",
loadingReport: "جارٍ تحميل التقرير",
tryAgain: "إعادة المحاولة",
jobNotFound: "لم يتم العثور على أمر العمل",
onlyOwnerCanShare: "يمكن فقط لمالك أمر العمل أو أحد أعضاء فريق الأصل مشاركة تقرير الإكمال.",
goBack: "رجوع",
completeAndVerifyFirst: "أنهِ هذه المهمة قبل مشاركة تقريرها.",
error: "خطأ",
jobNotFoundBody: "لم يُعثر على أمر العمل.",
notReadyTitle: "غير جاهز",
notReadyBody: "أنهِ هذه المهمة قبل مشاركة تقريرها.",
checkPhoneTitle: "تحقق من رقم الهاتف",
checkPhoneBody: "أدخل رقمًا صالحًا للبلد المحدد، أو اترك الهاتف فارغًا.",
resent: "أُعيد الإرسال",
sent: "تم الإرسال",
resentBody: "أُعيد إرسال التقرير. سيصله بريد جديد فيه الرابط.",
sentBody: "تم إرسال التقرير. سيصله بريد فيه رابط لمراجعة العمل.",
emailErrorLine: "\n\nخطأ: {{error}}",
emailFailedBody: "تعذر إرسال البريد الإلكتروني. شارك رابط المراجعة يدويًا:\n{{link}}{{errorLine}}",
shareCreatedTitle: "تم إنشاء المشاركة",
shareCreatedBody: "شارك هذا الرابط:\n{{link}}",
failedToCreateShare: "لم تتم مشاركة التقرير. تحقق من اتصالك وحاول مرة أخرى.",
devLinkWarning: "تستخدم روابط المشاركة localhost ولن تعمل لدى المستلمين. أضف EXPO_PUBLIC_WEB_APP_URL إلى ملف .env (رابط تطبيقك المنشور) وأعد التشغيل.",
prodLinkWarning: "لم يُعَدّ رابط ويب قابل للمشاركة لمساحة العمل هذه بعد، لذا قد لا يتمكن المستلمون من فتح رابط التقرير. يرجى التواصل مع المسؤول لديك.",
shareToLabel: "إرسال إلى",
shareToHint: "اضغط حدد جهة الاتصال واختر الشخص. يظهر في الأعلى من أرسلته إليهم من قبل.",
whoCanOpen: "لا يمكن فتح التقرير إلا لهذا الشخص. الرابط في بريده يسجّل دخوله مباشرة. أي شخص آخر يصله الرابط يمكنه فقط أن يطلب منك الوصول.",
changeContact: "تغيير جهة الاتصال",
selectContact: "حدد جهة الاتصال",
contactFallback: "جهة اتصال",
noEmailOrPhone: "لا يوجد بريد إلكتروني أو هاتف",
shareToContactTitle: "إرسال إلى",
howToSendLabel: "كيفية الإرسال",
shareViaLabel: "شارك عبر",
emailMethodLabel: "البريد الإلكتروني",
roleLabel: "الدور *",
recipientNameLabel: "الاسم (اختياري)",
recipientNamePlaceholder: "على سبيل المثال. جون سميث",
recipientEmailLabel: "البريد الإلكتروني *",
recipientEmailAria: "البريد الإلكتروني (مطلوب)",
recipientEmailPlaceholder: "client@example.com",
phoneOptionalLabel: "الهاتف (اختياري)",
shareStatusLabel: "أُرسل من قبل",
firstSharedLine: "أُرسل في {{date}}",
lastResharedLine: "أُعيد إرساله في {{date}}",
noResponseByDeadline: "لا رد حتى التاريخ المحدد. اضغط إرسال مرة أخرى للتذكير.",
responseDeadlineLabel: "الرد قبل (اختياري)",
selectDatePlaceholder: "اختر التاريخ",
messageOptionalLabel: "الرسالة (اختياري)",
messagePlaceholder: "إضافة ملاحظة للمستلم...",
actualCostOnReport: "التكلفة الفعلية في التقرير: {{amount}}",
sending: "جارٍ الإرسال…",
resend: "إرسال مرة أخرى",
send: "إرسال التقرير",
cancel: "إلغاء",
couldNotShareReportTitle: "تعذرت مشاركة التقرير",
sharingFailedFallback: "فشلت المشاركة. تحقق من اتصالك وحاول مرة أخرى.",
},
requestQuotes: {
includedItemsHeading: "العناصر المضمنة:",
excludedOrAssumptionsHeading: "مستبعد أو افتراضات:",
clarificationQuestionsHeading: "أسئلة توضيحية:",
addNotesFirstTitle: "أضف الملاحظات أولاً",
addNotesFirstBody: "اكتب الملاحظات أو أمليها، ثم استخدم الذكاء الاصطناعي لإعادة كتابتها.",
couldNotRewriteNotesTitle: "تعذر إعادة كتابة الملاحظات",
tryAgain: "حاول مرة أخرى.",
applyAiScopeDraftTitle: "تطبيق مسودة نطاق الذكاء الاصطناعي",
applyAiScopeDraftBody: "لديك نص نطاق بالفعل. هل تريد استبداله أم إلحاق مسودة الذكاء الاصطناعي به؟",
cancel: "إلغاء",
append: "إلحاق",
replace: "استبدال",
unableToGenerateScopeTitle: "غير قادر على إنشاء النطاق",
selectContractorsTitle: "حدد المقاولين",
selectContractorsBody: "اختر مقاولاً واحدًا على الأقل لدعوته.",
quoteRequestSent_one: "أُرسل طلب عرض السعر إلى مقاول واحد. سنُعلمك عند وصول العروض. قارِنها من هذا العمل.",
quoteRequestSent_other: "أُرسل طلب عرض السعر إلى {{count}} مقاول. سنُعلمك عند وصول العروض. قارِنها من هذا العمل.",
error: "خطأ",
failedToSendQuoteRequest: "فشل في إرسال طلب عرض الأسعار",
sendFailedTitle: "تعذّر إرسال طلب عرض السعر",
sendFailedBody: "لم يُرسل طلب عرض السعر. ما أدخلته ما زال هنا، فحاول مرة أخرى بعد قليل.",
noEmailNote: "لا يوجد بريد إلكتروني، لذا لن يصله هذا. أضِف بريدًا في صفحة جهة الاتصال.",
jobNotFound: "لم يُعثر على أمر العمل.",
notPrivateQuotesBody: "هذا العمل مُعدّ ليذهب إلى شخص واحد. لطلب سعر من عدة مقاولين، اضغط اطلب عروض أسعار بدلًا من ذلك.",
notPrivateQuotesLockedBody: "هذا العمل مُعدّ ليذهب إلى شخص واحد، ولا يمكن طلب عروض أسعار له الآن.",
switchToQuotes: "اطلب عروض أسعار بدلًا من ذلك",
switchingToQuotes: "جارٍ التبديل…",
switchFailedTitle: "تعذّر التحويل إلى عروض الأسعار",
switchFailedBody: "لم يتغيّر العمل. حاول مرة أخرى بعد قليل.",
backToJob: "العودة إلى العمل",
goBack: "رجوع",
jobTitleFallback: "طلب عرض سعر",
pageTitle: "طلب عروض أسعار",
inviteOnly: "بالدعوة فقط",
inviteTrustedHint: "قم بدعوة المقاولين الموثوقين من الدليل الخاص بك. هذه ليست قائمة عامة.",
scopeDescriptionLabel: "النطاق/الوصف",
scopeDescriptionPlaceholder: "ما العمل المطلوب؟",
generatingScope: "جارٍ الإنشاء...",
aiScope: "صياغة بالذكاء الاصطناعي",
notesOptionalLabel: "ملاحظات (اختياري)",
notesOptionalPlaceholder: "سياق إضافي للمقاولين",
rewriting: "جارٍ إعادة الكتابة...",
rewrite: "إعادة الصياغة",
aiScopeDraftDetailsTitle: "تفاصيل مسودة النطاق بالذكاء الاصطناعي",
includedLine: "المتضمن: {{items}}",
excludedLine: "المستبعد: {{items}}",
questionsLine: "أسئلة: {{items}}",
responseDeadlineLabel: "الموعد النهائي للرد (اختياري)",
respondByPlaceholder: "متى يجب أن يردوا؟",
responseTimeLabel: "وقت الرد (اختياري)",
selectTimePlaceholder: "حدد الوقت",
targetStartLabel: "البداية المستهدفة (اختياري)",
earliestStartPlaceholder: "أقرب تاريخ للبدء",
targetEndLabel: "النهاية المستهدفة (اختياري)",
latestEndPlaceholder: "آخر تاريخ انتهاء",
estimatedBudgetLabel: "الميزانية المقدرة (اختياري)",
photosLabel: "صور (اختياري، بحد أقصى 3)",
selectContractorsLabel: "حدد المقاولين لدعوتهم *",
selectContractorsHint: "ابحث في جهات الاتصال الخاصة بك وقم بالتصفية اختياريًا حسب المهارة أو النطاق. لم يتم اختيار أي شخص مسبقًا لك.",
requiredSkillsLabel: "المهارات المطلوبة",
addOrChangeContractors: "إضافة أو تغيير المقاولين",
chooseContractors: "اختر المقاولين",
selectedCount: "تم التحديد · {{count}}",
declinedToQuote: "اعتذر عن تقديم عرض سعر",
quoteSubmitted: "أُرسل عرض السعر",
alreadyInvited: "تمت دعوتهم بالفعل - في انتظار إجابتهم",
removeContact: "إزالة {{name}}",
noContractorsSelected: "لم يتم اختيار المقاولين بعد.",
creating: "جارٍ الإنشاء…",
sending: "جارٍ الإرسال…",
everyoneAlreadyInvited: "كل من تم اختياره مدعو بالفعل",
sendToMore_one: "أرسل إلى مقاول إضافي واحد",
sendToMore_other: "أرسل إلى {{count}} مقاول إضافي",
sendTo_one: "أرسل إلى مقاول واحد",
sendTo_other: "أرسل إلى {{count}} مقاول",
chooseContractorsForQuotesTitle: "اختر المقاولين لعروض الأسعار",
addContractor: "إضافة مقاول",
quoteRequestSent_zero: "لم يُرسل طلب عرض السعر إلى أي مقاول",
quoteRequestSent_two: "أُرسل طلب عرض السعر إلى مقاولين اثنين. سنُعلمك عند وصول العروض. قارِنها من هذا العمل.",
quoteRequestSent_few: "أُرسل طلب عرض السعر إلى {{count}} مقاولين. سنُعلمك عند وصول العروض. قارِنها من هذا العمل.",
quoteRequestSent_many: "أُرسل طلب عرض السعر إلى {{count}} مقاولًا. سنُعلمك عند وصول العروض. قارِنها من هذا العمل.",
sendToMore_zero: "لا مقاولين إضافيين",
sendToMore_two: "أرسل إلى مقاولين إضافيين اثنين",
sendToMore_few: "أرسل إلى {{count}} مقاولين إضافيين",
sendToMore_many: "أرسل إلى {{count}} مقاولًا إضافيًا",
sendTo_zero: "لا مقاولين للإرسال إليهم",
sendTo_two: "أرسل إلى مقاولين اثنين",
sendTo_few: "أرسل إلى {{count}} مقاولين",
sendTo_many: "أرسل إلى {{count}} مقاولًا",
},
quoteInvite: {
brief: {
forClient: "لصالح {{name}}",
replyBy: "الرد قبل {{date}}",
budget: "الميزانية {{amount}}",
starts: "البدء {{date}}",
finishBy: "الانتهاء قبل {{date}}",
due: "الموعد {{date}}",
whatTheyNeed: "ما يحتاجونه",
where: "المكان",
route: "المسار في خرائط Google",
photos: "صورهم",
},
form: {
title: "عرض السعر",
intro: "اذكر ما يشمله سعرك ثم الإجمالي. تراجع كل شيء قبل الإرسال.",
included: "ما يشمله",
labourOnly: "العمالة فقط",
labourAndMaterials: "العمالة والمواد",
coversLabel: "ما يغطيه سعرك",
coversPlaceholder: "مثال: توريد وتركيب أريكة جديدة بثلاثة مقاعد وإزالة القديمة",
total: "السعر الإجمالي",
totalTax: "شامل جميع الضرائب",
totalHelp: "أدرج ضريبة القيمة المضافة وأي ضرائب أخرى: هذا ما يدفعه العميل.",
warranty: "الضمان",
warrantyNone: "لا يوجد",
warranty3: "3 أشهر",
warranty6: "6 أشهر",
warranty12: "12 شهرًا",
warrantyPlaceholder: "أو اكتب ضمانك، مثال: سنتان على القطع",
takes: "المدة المطلوبة",
when: "متى يمكنك التنفيذ",
earliest: "أقرب موعد للبدء",
finishBy: "الانتهاء قبل",
files: "صور أو مستندات",
note: "ملاحظة للعميل (اختياري)",
notePlaceholder: "أي شيء آخر يجب أن يعرفوه",
review: "مراجعة وإرسال",
needPrice: "أدخل السعر الإجمالي للمتابعة.",
cantQuote: "لا أستطيع تقديم عرض لهذه المهمة",
},
review: {
title: "إرسال عرض السعر هذا؟",
subtitle: "إلى {{name}}",
subtitleNoName: "إلى العميل",
total: "الإجمالي شامل جميع الضرائب",
includes: "يشمل",
warranty: "الضمان",
takes: "المدة",
available: "التوفر",
files: "المرفقات",
filesCount: "{{n}} مرفق",
note: "ملاحظة",
send: "إرسال العرض",
change: "تعديل شيء",
from: "من {{date}}",
until: "حتى {{date}}",
},
declineSheet: {
title: "لا تستطيع تقديم عرض لهذه المهمة؟",
subtitle: "أخبر {{name}} بالسبب. سيرون سببك.",
subtitleNoName: "أخبر العميل بالسبب. سيرى سببك.",
reasonLabel: "لماذا؟",
no_availability: "لا يوجد وقت متاح",
outside_area: "خارج منطقتي",
not_my_work: "ليس من نوع عملي",
budget_or_timing: "الميزانية أو التوقيت غير مناسبين",
other: "سبب آخر",
noteLabel: "هل تريد إضافة شيء؟ (اختياري)",
noteLabelOther: "أخبرهم بالسبب",
notePlaceholder: "مثال: لا يوجد موعد متاح حتى ديسمبر",
send: "الاعتذار عن العرض",
chooseReason: "اختر سببًا للمتابعة.",
},
jobFallback: "عمل",
loadFailed: "لم يُحمَّل طلب عرض السعر هذا. تحقّق من اتصالك وحاول مرة أخرى.",
contextLoadFailed: "لم تُحمَّل تفاصيل طلب عرض السعر هذا. تحقّق من اتصالك وحاول مرة أخرى.",
notFound: "لم نجد طلب عرض السعر هذا، أو تمّ الرد عليه من قبل.",
alreadySent: "لقد أرسلت عرض سعر لهذا الطلب بالفعل.",
alreadyDeclined: "لقد رفضت طلب عرض السعر هذا.",
closedBody: "طلب عرض السعر هذا مغلق. اختار العميل عرضًا، أو انتهت المهلة، أو سُحب الطلب.",
deadlinePassed: "كانت مهلة هذا الطلب {{date}}، لذا لم يعد بإمكان العميل قبول عرض سعر.",
addNotesFirstTitle: "أضِف ملاحظات أولًا",
addNotesFirstBody: "اكتب الملاحظات أو أملِها، ثم اضغط إعادة الصياغة.",
rewriteFailedTitle: "تعذّرت إعادة صياغة الملاحظات",
rewriteFailedBody: "يُرجى المحاولة مرة أخرى.",
enterPriceTitle: "أدخل سعرك",
enterPriceBody: "اكتب السعر الإجمالي لهذا العمل، ثم اضغط إرسال عرض السعر.",
durationTitle: "راجِع المدة المقدّرة",
durationBody: "أدخل رقمًا أكبر من صفر، أو اترك الحقل فارغًا.",
durationPlaceholder: "مثلًا 2",
unit: {
hours: "ساعات",
days: "أيام",
weeks: "أسابيع",
},
dictate: "إملاء",
stop: "إيقاف",
rewrite: "إعادة الصياغة",
rewriting: "جارٍ إعادة الصياغة…",
submit: "إرسال عرض السعر",
submitting: "جارٍ الإرسال…",
sent: "أُرسل عرض السعر. سنُعلمك إن قبله العميل.",
sendFailedTitle: "تعذّر إرسال عرض السعر",
sendFailedBody: "لم يُرسل عرض السعر. ما أدخلته ما زال هنا، فحاول مرة أخرى بعد قليل.",
offlineSend: "أنت غير متصل. عرض السعر محفوظ على هذا الجهاز، فأرسِله عند عودة الاتصال.",
declineConfirmTitle: "رفض هذا الطلب؟",
declineConfirmBody: "سيُبلَّغ العميل بأنك لن تقدّم عرض سعر.",
cancel: "إلغاء",
decline: "رفض",
declined: "رُفض الطلب. أُبلغ العميل.",
declineFailedTitle: "تعذّر الرفض",
declineFailedBody: "لم يُرفض الطلب. حاول مرة أخرى بعد قليل.",
offlineDecline: "أنت غير متصل. ارفض الطلب عند عودة الاتصال.",
},
contractorNotTold: {
title: "لم يُبلَّغ أحد",
body: "عُيّن {{name}} لكن ليس لديه بريد إلكتروني، لذا لم يُبلَّغ. أضِف بريده الإلكتروني، ثم عيّنه مرة أخرى.",
},
created: {
  assignNow_many: "عيّنها الآن",
  assignNow_few: "عيّنها الآن",
  assignNow_two: "عيّنها الآن",
  assignNow_zero: "عيّنها الآن",
  assignNow_other: "عيّنها الآن",
  assignNow_one: "عيّنها الآن",
  subtitleAssignedTo: "في العمل ومسندة إلى {{names}}.",
  subtitleAssigned: "في العمل ومسندة.",
  changeWho: "تغيير المسؤول عنها",
  subtitleSolo_many: "إنها في العمل ومعيّنة لك.",
  subtitleSolo_few: "إنها في العمل ومعيّنة لك.",
  subtitleSolo_two: "إنها في العمل ومعيّنة لك.",
  subtitleSolo_zero: "إنها في العمل ومعيّنة لك.",
  subtitleSolo_other: "إنها في العمل ومعيّنة لك.",
  subtitleSolo_one: "إنها في العمل ومعيّنة لك.",
  subtitle_many: "إنها في العمل وغير معيّنة. لم يتم إبلاغ أحد بعد.",
  subtitle_few: "إنها في العمل وغير معيّنة. لم يتم إبلاغ أحد بعد.",
  subtitle_two: "إنها في العمل وغير معيّنة. لم يتم إبلاغ أحد بعد.",
  subtitle_zero: "إنها في العمل وغير معيّنة. لم يتم إبلاغ أحد بعد.",
  subtitle_other: "إنها في العمل وغير معيّنة. لم يتم إبلاغ أحد بعد.",
  subtitle_one: "إنها في العمل وغير معيّنة. لم يتم إبلاغ أحد بعد.",
title_one: "تم إنشاء أمر عمل واحد",
title_other: "تم إنشاء {{count}} أمر عمل",
subtitle: "إنها في العمل وغير معيّنة. لم يتم إبلاغ أحد بعد.",
listTitle: "المهام المُنشأة",
jobLink: "مهمة {{shortId}}",
backToRequest: "العودة إلى الطلب",
backToAsset: "العودة إلى الأصل",
backToJobs: "العودة إلى المهام",
technicalTitle: "تفاصيل تقنية",
technicalSummary: "معرّفات كاملة للمهمة والأصل للدعم أو التكامل.",
technicalJobIds: "معرّفات المهام",
technicalAssetId: "معرّف الأصل",
showMore: "عرض المزيد",
showLess: "عرض أقل",
title_zero: "لم يُنشأ أي أمر عمل",
title_two: "تم إنشاء أمري عمل",
title_few: "تم إنشاء {{count}} أوامر عمل",
title_many: "تم إنشاء {{count}} أمر عمل",
},
jobTags: {
urgency: {
low: "أولوية منخفضة",
medium: "أولوية متوسطة",
high: "أولوية عالية",
urgent: "عاجل",
critical: "حرج",
},
visibility: {
private: "خاص",
team: "الفريق",
public: "عام",
},
},
assigneeSuggestion: {
similarCompleted_zero: "لا مهام مكتملة مشابهة",
similarCompleted_one: "مهمة مكتملة مشابهة واحدة",
similarCompleted_two: "مهمتان مكتملتان مشابهتان",
similarCompleted_few: "{{count}} مهام مكتملة مشابهة",
similarCompleted_many: "{{count}} مهمةً مكتملةً مشابهة",
similarCompleted_other: "{{count}} مهمة مكتملة مشابهة",
skillMatches_zero: "لا مهام تتطابق مهاراتها المطلوبة",
skillMatches_one: "مهمة واحدة تتطابق مهاراتها المطلوبة",
skillMatches_two: "مهمتان تتطابق مهاراتهما المطلوبة",
skillMatches_few: "{{count}} مهام تتطابق مهاراتها المطلوبة",
skillMatches_many: "{{count}} مهمةً تتطابق مهاراتها المطلوبة",
skillMatches_other: "{{count}} مهمة تتطابق مهاراتها المطلوبة",
completedOnAsset_zero: "{{count}} مكتملة على هذا الأصل",
completedOnAsset_one: "{{count}} مكتملة على هذا الأصل",
completedOnAsset_two: "{{count}} مكتملة على هذا الأصل",
completedOnAsset_few: "{{count}} مكتملة على هذا الأصل",
completedOnAsset_many: "{{count}} مكتملة على هذا الأصل",
completedOnAsset_other: "{{count}} مكتملة على هذا الأصل",
activeAssignments_zero: "لا تعيينات نشطة",
activeAssignments_one: "تعيين نشط واحد",
activeAssignments_two: "تعيينان نشطان",
activeAssignments_few: "{{count}} تعيينات نشطة",
activeAssignments_many: "{{count}} تعيينًا نشطًا",
activeAssignments_other: "{{count}} تعيين نشط",
overdue_zero: "{{count}} متأخرة",
overdue_one: "{{count}} متأخرة",
overdue_two: "{{count}} متأخرة",
overdue_few: "{{count}} متأخرة",
overdue_many: "{{count}} متأخرة",
overdue_other: "{{count}} متأخرة",
separator: "، ",
},
quoteComparisonCopy: {
materialsIncluded: "المواد مشمولة؛ لا توجد استثناءات مذكورة",
materialsExcluded: "المواد مستثناة: {{details}}",
materialsMissing: "المواد مستثناة؛ التفاصيل مفقودة",
evidenceAttachments_zero: "لا أدلة مرفقة",
evidenceAttachments_one: "دليل مرفق واحد",
evidenceAttachments_two: "دليلان مرفقان",
evidenceAttachments_few: "{{count}} أدلة مرفقة",
evidenceAttachments_many: "{{count}} دليلًا مرفقًا",
evidenceAttachments_other: "{{count}} دليل مرفق",
noEvidence: "لا توجد أدلة مرفقة",
missingScope: "ما يشمله السعر",
missingTiming: "التوقيت",
durationHours_zero: "{{count}} ساعة",
durationHours_one: "ساعة واحدة",
durationHours_two: "ساعتان",
durationHours_few: "{{count}} ساعات",
durationHours_many: "{{count}} ساعةً",
durationHours_other: "{{count}} ساعة",
durationDays_zero: "{{count}} يوم",
durationDays_one: "يوم واحد",
durationDays_two: "يومان",
durationDays_few: "{{count}} أيام",
durationDays_many: "{{count}} يومًا",
durationDays_other: "{{count}} يوم",
durationWeeks_zero: "{{count}} أسبوع",
durationWeeks_one: "أسبوع واحد",
durationWeeks_two: "أسبوعان",
durationWeeks_few: "{{count}} أسابيع",
durationWeeks_many: "{{count}} أسبوعًا",
durationWeeks_other: "{{count}} أسبوع",
},
};
